import { useMemo } from "react";
import * as yup from "yup";
import { useState } from "react";
import DataTable from "react-data-table-component";
import "react-data-table-component-extensions/dist/index.css";
import DataTableExtensions from "react-data-table-component-extensions";
import { Button, Card } from "react-bootstrap";
import SelectCountry from "react-select-country-list";
import {
  AddSeason,
  DeleteColorCode,
  DeleteFeedback,
  DeleteGroup,
  DeleteGroupMember,
  DeleteHighScoreSingle,
  DeletePlayer,
  DeleteRaceResult,
  DeleteSeasonList,
  DeleteUser,
  GroupEdit,
  HighScoreUpdate,
  HighScoreUpdateContinent,
  PlayerEdit,
  RcaeResultEdit,
  StandingEdit,
  UsreEdit,
} from "../modals/allModal";
import { useFormik } from "formik";
import useDialogState from "../../hooks/useDialog";
import RaceService from "../../services/race.service";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useEffect } from "react";
import countryFlag from "../../../assets/img/svgs/FLAG PLACEHOLDER.png";
import UserService from "../../services/user.service";
import useMenuState, { useMenuState2 } from "../../hooks/useMenuState";
import StandingService from "../../services/standing.service";
import CountryService from "../../services/country.service";
import HighScoreService from "../../services/hiscore.service";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import instagram from "../../../assets/img/brand/instagram_2111463 1.png";
import xIcon from "../../../assets/img/brand/sl_z_072523_61700_01 1.png";
import Reddit from "../../../assets/img/brand/reddit 1.png";
import GroupService from "../../services/group.service";
import { enqueueSnackbar, useSnackbar } from "notistack";
import SeasonsService from "../../services/season.service";

const groupUsersByDate = (users) => {
  return users.reduce((result, user) => {
    const date = user.date;
    result[date] = result[date] || [];
    result[date].push(user);
    return result;
  }, {});
};

export const UserTable = (props) => {
  const {
    data,
    totalRows,
    dataPerPage,
    handlePageChange,
    handlePerPageChange,
    isLoading,
    getAllUser,
    handleData,
    modalShows,
    handleOpen,
    formik,
    handleDialogOpen,
    handleDialogClose,
    loader,
    handleFieldChange,
  } = props;

  // newest user is shown on top of the list
  const sortedData = data.sort((a, b) => new Date(b.date) - new Date(a.date));

  const groupedUsers = groupUsersByDate(sortedData);
  const flatData = Object.entries(groupedUsers).flatMap(
    ([date, users]) => users
  );

  const [openCity, handleOpenCity, handleCloseCity] = useMenuState(false);
  const [openCity2, handleOpenCity2, handleCloseCity2] = useMenuState2(false);
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const handleClose = () => setModalShow(false);
  const [id, setId] = useState("");
  const [userName, setUserName] = useState("");

  const handelShow = (id, name) => {
    setModalShow(true);
    setId(id);
    setUserName(name);
  };

  const columns = [
    {
      name: <b>UNIQUE CODE</b>,
      selector: (row) =>
        row.uniqueCode ? row.uniqueCode : "\u00A0".repeat(5) + "--",
      sortable: true,
    },
    {
      name: <b>FIRST NAME</b>,
      selector: (row) =>
        row.firstName ? row.firstName : "\u00A0".repeat(5) + "--",
      sortable: true,
    },
    {
      name: <b>LAST NAME</b>,
      selector: (row) =>
        row.lastName ? row.lastName : "\u00A0".repeat(5) + "--",
      sortable: true,
    },
    {
      name: <b>USER NAME</b>,
      selector: (row) =>
        row.userName ? row.userName : "\u00A0".repeat(5) + "--",
      sortable: true,
    },
    {
      name: <b>MOBILE NO.</b>,
      selector: (row) => (
        <div title={"+" + row.countryCode + " " + row.mobileNumber}>
          {row.countryCode !== undefined && row.mobileNumber
            ? "+" + row.countryCode + " " + row.mobileNumber
            : "\u00A0".repeat(5) + "--"}
        </div>
      ),
      sortable: true,
    },
    {
      name: <b>EMAIL</b>,
      selector: (row) => (
        <div title={row.email}>
          {row.email ? row.email : "\u00A0".repeat(5) + "--"}
        </div>
      ),
      sortable: true,
    },
    {
      name: <b>NATIONALITY</b>,
      selector: (row) => (
        <div title={row.nationality}>
          {row.nationality ? row.nationality : "\u00A0".repeat(5) + "--"}
        </div>
      ),
      sortable: true,
    },
    {
      name: <b>ROLE</b>,
      selector: (row) => row.roles,
      sortable: true,
    },
    {
      name: <b>SOCIAL LINKS</b>,
      selector: (row) => (
        <>
          <div className="d-flex">
            <div className="justify-content-center">
              {row.socialDetails && row.socialDetails[0]?.instagramAccount && (
                <button
                  className="btn  btn-sm"
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/" +
                      row.socialDetails[0]?.instagramAccount
                    )
                  }>
                  <img src={instagram} width="30px" height="30px" alt="" />
                </button>
              )}
              {row.socialDetails && row.socialDetails[0]?.redditAccount && (
                <button
                  style={{ marginLeft: "10px" }}
                  className="btn  btn-sm"
                  onClick={() =>
                    window.open(
                      "https://www.reddit.com/" +
                      row.socialDetails[0]?.redditAccount
                    )
                  }>
                  <img src={Reddit} width="30px" height="30px" alt="" />
                </button>
              )}
              {row.socialDetails && row.socialDetails[0]?.Xaccount && (
                <button
                  style={{ marginLeft: "10px" }}
                  className="btn  btn-sm"
                  onClick={() =>
                    window.open(
                      "https://twitter.com/" + row.socialDetails[0]?.Xaccount
                    )
                  }>
                  <img src={xIcon} width="30px" height="30px" alt="" />
                </button>
              )}

              {!row.socialDetails[0]?.instagramAccount &&
                !row.socialDetails[0]?.redditAccount &&
                !row.socialDetails[0]?.Xaccount &&
                "\u00A0".repeat(5) + "--"}
            </div>
          </div>
        </>
      ),
      width: "200px",
    },
    {
      name: <b>CREATED AT</b>,
      selector: (row) => (
        <div title={moment(row.createdAt).format("MM/MM/YYYY hh:mm")}>
          {row.createdAt
            ? moment(row.createdAt).format("MM/MM/YYYY hh:mm")
            : "\u00A0".repeat(5) + "--"}
        </div>
      ),
      sortable: true,
    },
    {
      name: <b>ACTION</b>,
      selector: (row) => (
        <>
          <div className="d-flex">
            <div className="justify-content-center">
              <button
                className="btn btn-primary btn-sm"
                onClick={() =>
                  navigate("/userprediction", {
                    state: {
                      id: row._id,
                    },
                  })
                }>
                <i className="fa fa-eye"></i>
              </button>
              <button
                style={{ marginLeft: "10px" }}
                className="btn btn-primary btn-sm"
                onClick={() => handleOpen(row._id)}>
                <i className="fa fa-pencil"></i>
              </button>
              <button
                style={{ marginLeft: "10px" }}
                className="btn btn-danger btn-sm"
                onClick={() => handelShow(row._id, row.userName)}>
                <i className="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </>
      ),
      width: "150px",
    },
  ];

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );

  const options = SelectCountry().getData();

  const CountryStatus = options.map((item) => ({
    label: item.label,
    value: item.value,
  }));

  const handleChange = (selectedOption) => {
    formik.setFieldValue("nationality", selectedOption.label);
    handleFieldChange("nationality", selectedOption.label);
  };

  return (
    <>
      <div lg={12} className="w-100">
        <Card className="custom-card overflow-hidden">
          <Card.Body>
            <div className="responsive">
              <Card className="custom-card overflow-hidden">
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginRight: "2px",
                      marginBottom: "10px",
                    }}>
                    <input
                      type="search"
                      style={{
                        border: "1px solid #e8e8f7",
                        padding: "0.375rem 0.75rem",
                        borderRadius: "7px",
                      }}
                      placeholder="Filter Table"
                      onChange={(e) => handleData(e)}
                    />
                  </div>
                  <DataTable
                    {...extensions}
                    data={flatData}
                    columns={columns}
                    noHeader
                    persistTableHead
                    pagination
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                    highlightOnHover
                    center={true}
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationRowsPerPageOptions={[5, 10, 50, 100]}
                    paginationPerPage={dataPerPage}
                    onChangeRowsPerPage={(page) => {
                      handlePerPageChange(page, 1);
                    }}
                    onChangePage={handlePageChange}
                    progressPending={isLoading}
                    progressComponent={
                      <CircularProgress
                        size={30}
                        style={{ marginTop: "50px" }}
                      />
                    }
                  />
                </div>
              </Card>
            </div>
          </Card.Body>
        </Card>
      </div>
      {modalShow && (
        <DeleteUser
          show={modalShow}
          onHide={handleClose}
          id={id}
          getAllUser={getAllUser}
          name={userName}
        />
      )}

      {modalShows && (
        <UsreEdit
          show={handleDialogOpen}
          onHide={handleDialogClose}
          loader={loader}
          formik={formik}
          // contryStatus={contryStatus}
          // changeStatus={changeStatus}
          openCity={openCity}
          handleCloseCity={handleCloseCity}
          handleOpenCity={handleOpenCity}
          openCity2={openCity2}
          handleCloseCity2={handleCloseCity2}
          handleOpenCity2={handleOpenCity2}
          handleFieldChange={handleFieldChange}
          CountryStatus={CountryStatus}
          handleChange={handleChange}
        />
      )}
    </>
  );
};

export const RaceTable = (props) => {
  const {
    data,
    totalRows,
    dataPerPage,
    handlePageChange,
    handlePerPageChange,
    isLoading,
    getAllResult,
    status,
  } = props;

  const [modalShowData, setModalShowData] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const handleCloseRace = () => setModalShowData(false);
  const [countryData, setCountryData] = useState([]);
  const handleClose = () => setModalShow(false);
  const [id, setId] = useState("");
  const [loader, setLoader] = useState(false);
  const [changes, setChanges] = useState({});
  const [openCity, handleOpenCity, handleCloseCity] = useMenuState(false);
  const [playerRaceDetailLength, setPlayerRaceDetailLength] = useState("");

  const handleDelete = (id) => {
    setModalShowData(true);
    setId(id);
  };

  const contryStatus = [
    ...countryData.map((item) => ({
      value: item._id,
      label: item.countryName,
    })),
  ];

  const initialValue = {
    userName: "",
    totalScore: "",
    playerRaceDetail: [
      {
        value: "",
        scoreValue: "",
      },
    ],
  };

  const pSeriesKeys = Array.from({ length: 10 }, (_, i) => `p${i + 1}`);
  const pSeriesKeys2 = Array.from({ length: 18 }, (_, i) => `p${i + 1}`);

  const handleFieldChange = (fieldName, value) => {
    setChanges({ ...changes, [fieldName]: value });
  };

  const getCountryList = async () => {
    const response = await CountryService.GetCountryListdrpdown();
    setCountryData(response.data.data);
  };

  useEffect(() => {
    getCountryList();
  }, []);

  const submit = async (values, action) => {
    try {
      setLoader(true);
      await RaceService.getSingleResult(values.resultId, values);
      setLoader(false);
      setModalShow(false);
      getAllResult();
      action.resetForm();
    } catch (error) {
      console.error("create race error", error);
      setLoader(false);
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    onSubmit: submit,
  });

  const handleOpen = async (id) => {
    setModalShow(true);
    const response = await RaceService.UpdateResult(id);
    const result = response.data.data;
    formik.setFieldValue("resultId", result._id);
    formik.setFieldValue("userName", result.userName);
    formik.setFieldValue("totalScore", result.totalScore);
    result.playerRaceDetail.forEach((phone, index) => {
      formik.setFieldValue(`playerRaceDetail[${index}].value`, phone.value);
      formik.setFieldValue(
        `playerRaceDetail[${index}].scoreValue`,
        phone.scoreValue
      );
    });
    setPlayerRaceDetailLength(result.playerRaceDetail.length);
  };

  const handleChangeData = (index, e) => {
    formik.setFieldValue(`playerRaceDetail[${index}].value`, e);
  };
  const handleChangeData2 = (index, e) => {
    formik.setFieldValue(`playerRaceDetail[${index}].scoreValue`, e);
  };

  const changeCountry = (value) => {
    formik.setFieldValue("playerCountryName", value.label);
    handleFieldChange("playerCountryName", value.label);
  };

  const columns = [
    {
      name: <b>ID</b>,
      // selector: (row) => row.order,
      selector: (row) => (row.order ? Math.floor(row.order) : row.order),
      sortable: true,
    },
    {
      name: <b>FIRST NAME</b>,
      selector: (row) => <div title={row.firstName}>{row.firstName}</div>,
      sortable: true,
    },
    {
      name: <b>LAST NAME</b>,
      selector: (row) => <div title={row.lastName}>{row.lastName}</div>,
      sortable: true,
    },
    {
      name: <b>THREE LATER NAME</b>,
      selector: (row) => row.threeLatterName,
      sortable: true,
    },
    {
      name: <b>RANK</b>,
      selector: (row) => row.hashtag,
      sortable: true,
    },
    {
      name: <b>COUNTRY IMAGE</b>,
      selector: (row) => {
        const countryName = row.playerCountryName;
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>
              <img
                src={
                  row.countryImage === null || row.countryImage === undefined
                    ? countryFlag
                    : row.countryImage
                }
                width="30px"
                height="30px"
                style={{
                  marginLeft: "auto",
                  marginRight: "15px",
                  border: "1px solid",
                }}
                alt="country"
              />
            </div>
            <div style={{ marginLeft: "10px" }}>{countryName}</div>
          </div>
        );
      },
      sortable: true,
      width: "150px",
    },
    ...(status
      ? pSeriesKeys.map((key, index) => ({
        name: <b>{`P${index + 1} (Race)`}</b>,
        selector: (row) => {
          const pValue = row.playerRaceDetail[index];
          return pValue ? (
            <span>
              {pValue.value}
              {pValue.scoreValue === undefined
                ? pValue.scoreValue
                : `(${pValue.scoreValue})`}
            </span>
          ) : (
            ""
          );
        },
        sortable: true,
      }))
      : pSeriesKeys2.map((key, index) => ({
        name:
          index < 8 ? (
            <b>{`P${index + 1} (Sprint)`}</b>
          ) : (
            <b>{`P${index - 7} (Race)`}</b>
          ),
        selector: (row) => {
          const pValue = row.playerRaceDetail[index];
          return pValue ? (
            <span>
              {pValue.value}
              {pValue.scoreValue === undefined
                ? pValue.scoreValue
                : `(${pValue.scoreValue})`}
            </span>
          ) : (
            ""
          );
        },
        sortable: true,
      }))),
    {
      name: <b>Fastest Lap</b>,
      selector: (row) =>
        status ? (
          <span>
            {row.playerRaceDetail[10]?.value}{" "}
            {row.playerRaceDetail[10]?.scoreValue === undefined
              ? row.playerRaceDetail[10]?.scoreValue
              : `(${row.playerRaceDetail[10]?.scoreValue})`}
          </span>
        ) : (
          <span>
            {row.playerRaceDetail[18]?.value}{" "}
            {row.playerRaceDetail[18]?.scoreValue === undefined
              ? row.playerRaceDetail[10]?.scoreValue
              : `(${row.playerRaceDetail[10]?.scoreValue})`}
          </span>
        ),
      sortable: true,
    },
    {
      name: <b>TOTAL RACE</b>,
      selector: (row) =>
        row?.totalRace !== null && row?.totalRace !== undefined
          ? Number(row.totalRace).toFixed(2)
          : "-",
      sortable: true,
    },
    {
      name: <b>TOTAL SPRINT</b>,
      selector: (row) =>
        row?.totalSprint !== null && row?.totalSprint !== undefined
          ? Number(row.totalSprint).toFixed(2)
          : "  -",
      sortable: true,
    },
    {
      name: <b>TOTAL SCORE</b>,
      selector: (row) =>
        row?.totalScore !== null && row?.totalScore !== undefined
          ? Number(row.totalScore).toFixed(2)
          : "  -",
      sortable: true,
    },
    {
      name: <b>ACTION</b>,
      selector: (row, index) => (
        <>
          <div className="d-flex">
            {index !== 0 && (
              <>
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => handleOpen(row._id)}>
                  <i className="fa fa-pencil"></i>
                </button>
                <div style={{ marginLeft: "10px" }}>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(row._id)}>
                    <i className="fe fe-trash"></i>
                  </button>
                </div>
              </>
            )}
          </div>
        </>
      ),
      width: "100px",
    },
  ];

  const tableData = {
    columns,
    data,
  };

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );
  return (
    <>
      <div lg={12} className="w-100">
        <Card className="custom-card overflow-hidden">
          <Card.Body>
            <div className="responsive">
              <Card className="custom-card overflow-hidden">
                <div>
                  <h6
                    className="main-content-label mb-1 fs-20"
                    style={{ marginLeft: "5px" }}>
                    Race Result
                  </h6>
                </div>
                <div>
                  <DataTableExtensions {...tableData}>
                    <DataTable
                      {...extensions}
                      noHeader
                      persistTableHead
                      pagination
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        width: "100%",
                        overflowX: "auto",
                      }}
                      highlightOnHover
                      center={true}
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationPerPage={dataPerPage}
                      onChangeRowsPerPage={(page, totalRows) => {
                        handlePerPageChange(page, 1);
                      }}
                      onChangePage={handlePageChange}
                      progressPending={isLoading}
                      progressComponent={
                        <CircularProgress
                          size={30}
                          style={{ marginTop: "50px" }}
                        />
                      }
                    />
                  </DataTableExtensions>
                </div>
              </Card>
            </div>
          </Card.Body>
        </Card>
      </div>
      {modalShowData && (
        <DeleteRaceResult
          show={modalShowData}
          id={id}
          onHide={handleCloseRace}
          getAllResult={getAllResult}
        />
      )}
      {modalShow && (
        <RcaeResultEdit
          show={modalShow}
          onHide={handleClose}
          loader={loader}
          formik={formik}
          contryStatus={contryStatus}
          changeStatus={changeCountry}
          openCity={openCity}
          handleCloseCity={handleCloseCity}
          handleOpenCity={handleOpenCity}
          playerRaceDetailLength={playerRaceDetailLength}
          handleFieldChange={handleFieldChange}
          handleChangeData={handleChangeData}
          handleChangeData2={handleChangeData2}
        />
      )}
    </>
  );
};



export const RacePlayerTable = (props) => {
  const {
    data,
    singleId,
    sendData,
    handleData,
    isLoadingPlayer,
    selectedType,
    contryStatus,
    openCity,
    handleOpenCity,
    handleCloseCity,
    setIsLoadingPlayer,
    getPlayer,
    setPlayer
  } = props;
  const [modalShow, setModalShow] = useState(false);
  const [dataList, setDataList] = useState([]);
  const handleClose = () => setModalShow(false);
  const [update, setUpdate] = useState(false);
  const [resultData, setResultData] = useState([]);
  const [playerId, setPlayerId] = useState("");
  const [playerName, setPlayerName] = useState("");
  const [loader, setLoader] = useState(false);
  const [currentPlayerId, setCurrentPlayerId] = useState("");
  const [currentPlayerOrder, setCurrentPlayerOrder] = useState("");
  const {
    open: modalShows,
    handleClickOpen: handleDialogOpen,
    handleClose: handleDialogClose,
  } = useDialogState();

  const schema = yup.object().shape({
    playerName: yup.string().required("Please Enter Player Name"),
    playerInfo: yup.string().required("Please Enter Player Info"),
    playerCountry: yup.string().required("Please Select Country"),
    playerOrder: yup
      .number()
      .required("Please Enter Player Order")
      .test(
        "unique-order",
        "This player order already exists",
        function (value) {
          if (!value) return true;

          // If updating and value is same as current player order, skip validation
          if (update && value === currentPlayerOrder) {
            return true; // Skip duplicate check for same value
          }

          const isDuplicate = data.some(item => {
            // For update: exclude current player from check
            if (update && item.id === currentPlayerId) {
              return false; // Skip current player
            }
            return item.playerOrder === value;
          });

          return !isDuplicate;
        }
      ),
  });

  const initialValue = {
    playerName: "",
    playerInfo: "",
    playerCountry: "",
    playerOrder: "",
  };
  useEffect(() => {
    sendData(dataList);
  }, [dataList]);

  const submit = async (values, action) => {
    try {
      if (update) {
        const updatedValue = {
          raceStatus: resultData.raceStatus,
          data: values,
          type: selectedType?.toUpperCase(),
        };
        setLoader(true);
        const response = await RaceService.UpdateRacing(singleId, updatedValue);
        setDataList(response.data.data.playerDetail);
        if (response.status === 200 || response.status === 201) {
          enqueueSnackbar("Player Updated Successfully", {
            variant: "success",
          });
        }
      } else {
        const lastOrder = data?.at(-1)?.playerOrder;
        const body = {
          name: values?.playerName || "",
          info: values?.playerInfo || "",
          order: values?.playerOrder || lastOrder + 1 || "",
          country: values?.playerCountry || "",
          raceId: singleId
        };
        setLoader(true);
        const response = await RaceService.addPlayerToRace(body);
        if (response.status === 200 || response.status === 201) {
          enqueueSnackbar("Player Added Successfully", {
            variant: "success",
          });
        }
      }
      try {
        setIsLoadingPlayer(true);
        const response = await RaceService.GetSingleRace(singleId);
        setPlayer(response.data.data.playerDetail);
      } catch (error) {
        console.error("create country error", error);
      } finally {
        setIsLoadingPlayer(false);
      }
      setLoader(false);
      setModalShow(false);
      data();
      getPlayer();
      action.resetForm();
    } catch (error) {
      console.error("create country error", error);
    } finally {
      data();
      getPlayer();
      setLoader(false);
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });

  const handleDeleteOpen = async (id, name) => {
    handleDialogOpen();
    setPlayerId(id);
    setPlayerName(name);
  };


  const changeCountry = (value) => {
    formik.setFieldValue("playerCountry", value.label);
  };

  const handleOpen = async (id) => {
    setModalShow(true);
    const response = await RaceService.GetSingleRace(singleId);
    const result = response.data.data;
    setResultData(result);
    if (id) {
      const player = result.playerDetail.find((player) => player._id === id);
      setUpdate(true);
      formik.resetForm();
      formik.setFieldValue("playerCountry", "");
      formik.setFieldValue("playerName", player.playerName.replace(/-/g, " "));
      formik.setFieldValue("playerInfo", player.playerInfo.replace(/-/g, " "));
      formik.setFieldValue("raceStatus", result.raceStatus);
      formik.setFieldValue("playerId", player._id);
      formik.setFieldValue("playerOrder", player.playerOrder || "");
      formik.setFieldValue("playerCountry", player.playerCountry);
      setCurrentPlayerOrder(player.playerOrder);
      setCurrentPlayerId(player._id);
    } else {
      formik.resetForm();
      formik.setFieldValue("playerCountry", "");
      const player = result.playerDetail.find((player) => player._id === id);
      setUpdate(false);
      formik.setFieldValue("raceStatus", result.raceStatus);
      formik.setFieldValue("playerDetail", result.playerDetail);
      formik.setFieldValue("playerCountry", player.playerCountry);
      formik.setFieldValue("playerOrder", result.playerDetail?.length + 1 || "");
      formik.setFieldValue("playerName", "");
      formik.setFieldValue("playerInfo", "");
    }
  };
  const columns = [
    {
      name: <b>ID</b>,
      selector: (row) => row._id,
      sortable: true,
    },

    {
      name: <b>PLAYER COUNTRY</b>,
      selector: (row) => {
        const countryName = row.playerCountry;
        return (
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <div>
              <img
                src={row.playerImage !== null && countryName ? row.playerImage : countryFlag}
                width="30px"
                height="30px"
                style={{
                  marginLeft: "auto",
                  marginRight: "15px",
                  border: "1px solid",
                  flexShrink: 0,
                }}
                alt="country"
              />
            </div>
            <div
              style={{
                marginLeft: "10px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "140px",
              }}>
              {countryName}
            </div>
          </div>
        );
      },
      sortable: true,
      width: "200px",
    },
    {
      name: <b>PLAYER NAME</b>,
      selector: (row) => row.playerName,
      sortable: true,
      center: true,
    },
    {
      name: <b>PLAYER CAR</b>,
      selector: (row) => <div>{row.playerInfo}</div>,
      sortable: true,
      center: true,
    },
    {
      name: <b>PLAYER ORDER</b>,
      selector: (row) => <div title={row.playerOrder}>{row.playerOrder || "-"}</div>,
      sortable: true,
      width: "200px",
      center: true,
    },
    {
      name: <b>ACTION</b>,
      selector: (row) => (
        <>
          <div className="d-flex">
            <div className="justify-content-center">
              <button
                className="btn btn-primary btn-sm"
                onClick={() => handleOpen(row._id)}>
                <i className="fa fa-pencil"></i>
              </button>
            </div>
            <div
              className="justify-content-center"
              style={{ marginLeft: "10px" }}>
              <button
                className="btn btn-danger btn-sm"
                onClick={() => handleDeleteOpen(row._id, row.playerName)}>
                <i className="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </>
      ),
      width: "120px",
    },
  ];

  const tableData = {
    columns,
    data,
  };

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );
  return (
    <>
      <div
        className="custom-card text-end  pointer"
        style={{ marginRight: "18px" }}>
        <Button className="text-white mb-3" onClick={() => handleOpen("")}>
          <i className="fas fa-plus"></i> &nbsp; Add Player
        </Button>
        <div lg={12} className="w-100">
          <Card className="custom-card overflow-hidden">
            <Card.Body>
              <div className="responsive">
                <Card className="custom-card overflow-hidden">
                  <div>
                    <h6
                      className="main-content-label mb-1 fs-20"
                      style={{ marginLeft: "5px", display: "flex" }}>
                      Race Detail
                    </h6>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginRight: "2px",
                      marginBottom: "10px",
                    }}>
                    <input
                      type="search"
                      style={{
                        border: "1px solid #e8e8f7",
                        padding: "0.375rem 0.75rem",
                        borderRadius: "7px",
                      }}
                      placeholder="Filter Table"
                      onChange={(e) => handleData(e)}
                    />
                  </div>
                  <div>
                    <DataTableExtensions {...tableData} filter={false}>
                      <DataTable
                        {...extensions}
                        noHeader
                        persistTableHead
                        progressPending={isLoadingPlayer}
                        progressComponent={
                          <CircularProgress
                            size={30}
                            style={{ marginTop: "50px" }}
                          />
                        }
                        pagination
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                        }}
                        highlightOnHover
                      />
                    </DataTableExtensions>
                  </div>
                </Card>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
      {modalShow && (
        <PlayerEdit
          data={data}
          currentPlayerId={currentPlayerId}
          show={modalShow}
          contryStatus={contryStatus}
          changeCountry={changeCountry}
          openCity={openCity}
          handleOpenCity={handleOpenCity}
          handleCloseCity={handleCloseCity}
          onHide={handleClose}
          formik={formik}
          update={update}
          loader={loader}
        />
      )}
      {modalShows && (
        <DeletePlayer
          getPlayer={getPlayer}
          show={modalShows}
          onHide={handleDialogClose}
          id={singleId}
          playerId={playerId}
          formik={formik}
          playerName={playerName}
          data={data}
          selectedType={selectedType}
        />
      )}
    </>
  );
};

export const PredictUserTable = (props) => {
  const {
    data,
    totalRows,
    handlePerPageChange,
    handlePageChange,
    isLoading,
    dataPerPage,
    status,
  } = props;

  const columns = status
    ? [
      {
        name: <b>FIRST NAME</b>,
        selector: (row) => <div title={row.firstName}>{row.firstName}</div>,
        sortable: true,
      },
      {
        name: <b>LAST NAME</b>,
        selector: (row) => <div title={row.lastName}>{row.lastName}</div>,
        sortable: true,
      },
      {
        name: <b>USER NAME</b>,
        selector: (row) => <div title={row.userName}>{row.userName}</div>,
        sortable: true,
      },
      {
        name: <b>UNIQUE CODE</b>,
        selector: (row) => <div title={row.uniqueCode}>{row.uniqueCode}</div>,
        sortable: true,
      },
      {
        name: <b>EMAIL</b>,
        selector: (row) => <div title={row.email}>{row.email}</div>,
        sortable: true,
      },
      {
        name: <b> MOBILE NUMBER</b>,
        selector: (row) => (
          <div title={row.mobileNumber}>{row.mobileNumber}</div>
        ),
        sortable: true,
      },
      {
        name: <b>P1 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 0) {
            return (
              <>
                <div title={row.raceDetail[0].answer}>
                  {row.raceDetail[0].answer[0]}
                </div>
                <div title={row.raceDetail[0].answer}>
                  ({row.raceDetail[0].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P2 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 0) {
            return (
              <>
                <div title={row.raceDetail[1].answer}>
                  {row.raceDetail[1].answer[0]}
                </div>
                <div title={row.raceDetail[1].answer}>
                  ({row.raceDetail[1].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P3 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 0) {
            return (
              <>
                <div title={row.raceDetail[2].answer}>
                  {row.raceDetail[2].answer[0]}
                </div>
                <div title={row.raceDetail[2].answer}>
                  ({row.raceDetail[2].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P4 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 0) {
            return (
              <>
                <div title={row.raceDetail[3].answer}>
                  {row.raceDetail[3].answer[0]}
                </div>
                <div title={row.raceDetail[3].answer}>
                  ({row.raceDetail[3].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P5 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 0) {
            return (
              <>
                <div title={row.raceDetail[4].answer}>
                  {row.raceDetail[4].answer[0]}
                </div>
                <div title={row.raceDetail[4].answer}>
                  ({row.raceDetail[4].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P6 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 0) {
            return (
              <>
                <div title={row.raceDetail[5].answer}>
                  {row.raceDetail[5].answer[0]}
                </div>
                <div title={row.raceDetail[5].answer}>
                  ({row.raceDetail[5].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P7 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 0) {
            return (
              <>
                <div title={row.raceDetail[6].answer}>
                  {row.raceDetail[6].answer[0]}
                </div>
                <div title={row.raceDetail[6].answer}>
                  ({row.raceDetail[6].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P8 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 0) {
            return (
              <>
                <div title={row.raceDetail[7].answer}>
                  {row.raceDetail[7].answer[0]}
                </div>
                <div title={row.raceDetail[7].answer}>
                  ({row.raceDetail[7].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P9 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 0) {
            return (
              <>
                <div title={row.raceDetail[8].answer}>
                  {row.raceDetail[8].answer[0]}
                </div>
                <div title={row.raceDetail[8].answer}>
                  ({row.raceDetail[8].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P10 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 0) {
            return (
              <>
                <div title={row.raceDetail[9].answer}>
                  {row.raceDetail[9].answer[0]}
                </div>
                <div title={row.raceDetail[9].answer}>
                  ({row.raceDetail[9].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>FASTEST LAP</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 0) {
            return (
              <>
                <div title={row.raceDetail[10]?.answer}>
                  {row.raceDetail[10]?.answer[0]}
                </div>
                <div title={row.raceDetail[10]?.answer}>
                  ({row.raceDetail[10]?.answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
    ]
    : [
      {
        name: <b>USER NAME</b>,
        selector: (row) => row.userName,
        sortable: true,
      },
      {
        name: <b>P1 (SPRINT)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[0].answer}>
                  {row.raceDetail[0].answer[0]}
                </div>
                <div title={row.raceDetail[0].answer}>
                  ({row.raceDetail[0].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P2 (SPRINT)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[1].answer}>
                  {row.raceDetail[1].answer[0]}
                </div>
                <div title={row.raceDetail[1].answer}>
                  ({row.raceDetail[1].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P3 (SPRINT)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[2].answer}>
                  {row.raceDetail[2].answer[0]}
                </div>
                <div title={row.raceDetail[2].answer}>
                  ({row.raceDetail[2].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P4 (SPRINT)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[3].answer}>
                  {row.raceDetail[3].answer[0]}
                </div>
                <div title={row.raceDetail[3].answer}>
                  ({row.raceDetail[3].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P5 (SPRINT)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[4].answer}>
                  {row.raceDetail[4].answer[0]}
                </div>
                <div title={row.raceDetail[4].answer}>
                  ({row.raceDetail[4].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P6 (SPRINT)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[5].answer}>
                  {row.raceDetail[5].answer[0]}
                </div>
                <div title={row.raceDetail[5].answer}>
                  ({row.raceDetail[5].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P7 (SPRINT)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[6].answer}>
                  {row.raceDetail[6].answer[0]}
                </div>
                <div title={row.raceDetail[6].answer}>
                  ({row.raceDetail[6].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P8 (SPRINT)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[7].answer}>
                  {row.raceDetail[7].answer[0]}
                </div>
                <div title={row.raceDetail[7].answer}>
                  ({row.raceDetail[7].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P1 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[8].answer}>
                  {row.raceDetail[8].answer[0]}
                </div>
                <div title={row.raceDetail[8].answer}>
                  ({row.raceDetail[8].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P2 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[9].answer}>
                  {row.raceDetail[9].answer[0]}
                </div>
                <div title={row.raceDetail[9].answer}>
                  ({row.raceDetail[9].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P3 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[10].answer}>
                  {row.raceDetail[10].answer[0]}
                </div>
                <div title={row.raceDetail[10].answer}>
                  ({row.raceDetail[10].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P4 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[11].answer}>
                  {row.raceDetail[11].answer[0]}
                </div>
                <div title={row.raceDetail[11].answer}>
                  ({row.raceDetail[11].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P5 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[12].answer}>
                  {row.raceDetail[12].answer[0]}
                </div>
                <div title={row.raceDetail[12].answer}>
                  ({row.raceDetail[12].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P6 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[13].answer}>
                  {row.raceDetail[13].answer[0]}
                </div>
                <div title={row.raceDetail[13].answer}>
                  ({row.raceDetail[13].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P7 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[14].answer}>
                  {row.raceDetail[14].answer[0]}
                </div>
                <div title={row.raceDetail[14].answer}>
                  ({row.raceDetail[14].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P8 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[15].answer}>
                  {row.raceDetail[15].answer[0]}
                </div>
                <div title={row.raceDetail[15].answer}>
                  ({row.raceDetail[15].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P9 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[16].answer}>
                  {row.raceDetail[16].answer[0]}
                </div>
                <div title={row.raceDetail[16].answer}>
                  ({row.raceDetail[16].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>P10 (RACE)</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[17].answer}>
                  {row.raceDetail[17].answer[0]}
                </div>
                <div title={row.raceDetail[17].answer}>
                  ({row.raceDetail[17].answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
      {
        name: <b>FASTEST LAP</b>,
        selector: (row) => {
          if (row.raceDetail && row.raceDetail.length > 11) {
            return (
              <>
                <div title={row.raceDetail[18]?.answer}>
                  {row.raceDetail[18]?.answer[0]}
                </div>
                <div title={row.raceDetail[18]?.answer}>
                  ({row.raceDetail[18]?.answer[1]})
                </div>
              </>
            );
          }
        },
        sortable: true,
      },
    ];

  const tableData = {
    columns,
    data,
  };

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );
  return (
    <>
      <div lg={12} className="w-100">
        <Card className="custom-card overflow-hidden">
          <Card.Body>
            <div className="responsive">
              <Card className="custom-card overflow-hidden">
                <div>
                  <h6
                    className="main-content-label mb-1 fs-20"
                    style={{ marginLeft: "5px" }}>
                    Players prediction Detail
                  </h6>
                </div>
                <div>
                  <DataTableExtensions {...tableData}>
                    <DataTable
                      {...extensions}
                      noHeader
                      persistTableHead
                      pagination
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                      highlightOnHover
                      center={true}
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationPerPage={dataPerPage}
                      onChangeRowsPerPage={(page, totalRows) => {
                        handlePerPageChange(page, 1);
                      }}
                      onChangePage={handlePageChange}
                      progressPending={isLoading}
                      progressComponent={
                        <CircularProgress
                          size={30}
                          style={{ marginTop: "50px" }}
                        />
                      }
                    />
                  </DataTableExtensions>
                </div>
              </Card>
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export const SingleUserTable11 = (props) => {
  const { data } = props;

  const columns = [
    {
      name: <b>USER NAME</b>,
      selector: (row) => <div title={row.userName}>{row.userName}</div>,
      sortable: true,
    },
    {
      name: <b>P1 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 0) {
          return (
            <>
              <div title={row.raceDetail[0]?.answer}>
                {row.raceDetail[0]?.answer[0]}
              </div>
              <div title={row.raceDetail[0]?.answer}>
                ({row.raceDetail[0]?.answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P2 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 0) {
          return (
            <>
              <div title={row.raceDetail[0]?.answer}>
                {row.raceDetail[1]?.answer[0]}
              </div>
              <div title={row.raceDetail[0]?.answer}>
                ({row.raceDetail[1]?.answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P3 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail?.length > 0) {
          return (
            <>
              <div title={row.raceDetail[0]?.answer}>
                {row.raceDetail[2]?.answer[0]}
              </div>
              <div title={row.raceDetail[0]?.answer}>
                ({row.raceDetail[2]?.answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P4 (RACE)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail?.length > 0) {
          return (
            <>
              <div title={row?.raceDetail[0]?.answer}>
                {row?.raceDetail[3]?.answer[0]}
              </div>
              <div title={row?.raceDetail[0]?.answer}>
                ({row?.raceDetail[3]?.answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P5 (RACE)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail?.length > 0) {
          return (
            <>
              <div title={row?.raceDetail[0]?.answer}>
                {row.raceDetail[4]?.answer[0]}
              </div>
              <div title={row?.raceDetail[0]?.answer}>
                ({row?.raceDetail[4]?.answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P6 (RACE)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail?.length > 0) {
          return (
            <>
              <div title={row?.raceDetail[0]?.answer}>
                {row?.raceDetail[5]?.answer[0]}
              </div>
              <div title={row.raceDetail[0]?.answer}>
                ({row?.raceDetail[5]?.answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P7 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 0) {
          return (
            <>
              <div title={row?.raceDetail[0]?.answer}>
                {row?.raceDetail[6]?.answer[0]}
              </div>
              <div title={row?.raceDetail[0]?.answer}>
                ({row?.raceDetail[6]?.answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P8 (RACE)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail?.length > 0) {
          return (
            <>
              <div title={row.raceDetail[0].answer}>
                {row.raceDetail[7]?.answer[0]}
              </div>
              <div title={row?.raceDetail[0]?.answer}>
                ({row?.raceDetail[7]?.answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P9 (RACE)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail?.length > 0) {
          return (
            <>
              <div title={row?.raceDetail[0]?.answer}>
                {row?.raceDetail[8]?.answer[0]}
              </div>
              <div title={row.raceDetail[0]?.answer}>
                ({row?.raceDetail[8]?.answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P10 (RACE)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail?.length > 0) {
          return (
            <>
              <div title={row?.raceDetail[0]?.answer}>
                {row?.raceDetail[9]?.answer[0]}
              </div>
              <div title={row?.raceDetail[0]?.answer}>
                ({row?.raceDetail[9]?.answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>FASTEST LAP</b>,
      selector: (row) => {
        if (row.raceDetail && row?.raceDetail?.length > 0) {
          return (
            <>
              <div title={row.raceDetail[0]?.answer}>
                {row?.raceDetail[10]?.answer[0]}
              </div>
              {row?.raceDetail[10]?.answer[1] ? <div title={row?.raceDetail[0]?.answer}>
                ({row?.raceDetail[10]?.answer[1]})
              </div> : "-"}
            </>
          );
        }
      },
      sortable: true,
    },
  ];

  const tableData = {
    columns,
    data,
  };

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );
  return (
    <>
      <div lg={12} className="w-100">
        <Card className="custom-card overflow-hidden">
          <Card.Body>
            <div className="responsive">
              <Card className="custom-card overflow-hidden">
                <div>
                  <h6
                    className="main-content-label mb-1 fs-20"
                    style={{ marginLeft: "5px" }}>
                    PLayer 10 prediction Detail (F1)
                  </h6>
                </div>
                <div>
                  <DataTableExtensions {...tableData}>
                    <DataTable
                      {...extensions}
                      noHeader
                      persistTableHead
                      pagination
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                      highlightOnHover
                    />
                  </DataTableExtensions>
                </div>
              </Card>
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export const SingleUserTable19 = (props) => {
  const { data } = props;

  const columns = [
    {
      name: <b>USER NAME</b>,
      selector: (row) => row.userName,
      sortable: true,
    },
    {
      name: <b>P1 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[0].answer}>
                {row.raceDetail[0].answer[0]}
              </div>
              <div title={row.raceDetail[0].answer}>
                ({row.raceDetail[0].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P2 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[1].answer}>
                {row.raceDetail[1].answer[0]}
              </div>
              <div title={row.raceDetail[1].answer}>
                ({row.raceDetail[1].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P3 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[2].answer}>
                {row.raceDetail[2].answer[0]}
              </div>
              <div title={row.raceDetail[2].answer}>
                ({row.raceDetail[2].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P4 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[3].answer}>
                {row.raceDetail[3].answer[0]}
              </div>
              <div title={row.raceDetail[3].answer}>
                ({row.raceDetail[3].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P5 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[4].answer}>
                {row.raceDetail[4].answer[0]}
              </div>
              <div title={row.raceDetail[4].answer}>
                ({row.raceDetail[4].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P6 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[5].answer}>
                {row.raceDetail[5].answer[0]}
              </div>
              <div title={row.raceDetail[5].answer}>
                ({row.raceDetail[5].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P7 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[6].answer}>
                {row.raceDetail[6].answer[0]}
              </div>
              <div title={row.raceDetail[6].answer}>
                ({row.raceDetail[6].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P8 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[7].answer}>
                {row.raceDetail[7].answer[0]}
              </div>
              <div title={row.raceDetail[7].answer}>
                ({row.raceDetail[7].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P1 (SPRINT)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row?.raceDetail[8]?.answer}>
                {row?.raceDetail[8]?.answer[0]}
              </div>
              <div title={row?.raceDetail[8]?.answer}>
                ({row?.raceDetail[8]?.answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P2 (SPRINT)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[9].answer}>
                {row.raceDetail[9].answer[0]}
              </div>
              <div title={row.raceDetail[9].answer}>
                ({row.raceDetail[9].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P3 (SPRINT)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[10].answer}>
                {row.raceDetail[10].answer[0]}
              </div>
              <div title={row.raceDetail[10].answer}>
                ({row.raceDetail[10].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P4 (SPRINT)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[11].answer}>
                {row.raceDetail[11].answer[0]}
              </div>
              <div title={row.raceDetail[11].answer}>
                ({row.raceDetail[11].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P5 (SPRINT)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail.length > 11) {
          return (
            <>
              <div title={row?.raceDetail[12].answer}>
                {row?.raceDetail[12].answer[0]}
              </div>
              <div title={row?.raceDetail[12].answer}>
                ({row?.raceDetail[12].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P6 (SPRINT)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail.length > 11) {
          return (
            <>
              <div title={row?.raceDetail[13].answer}>
                {row?.raceDetail[13].answer[0]}
              </div>
              <div title={row?.raceDetail[13].answer}>
                ({row?.raceDetail[13].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P7 (SPRINT)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail.length > 11) {
          return (
            <>
              <div title={row?.raceDetail[14].answer}>
                {row?.raceDetail[14].answer[0]}
              </div>
              <div title={row?.raceDetail[14].answer}>
                ({row?.raceDetail[14].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P8 (SPRINT)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail.length > 11) {
          return (
            <>
              <div title={row?.raceDetail[15].answer}>
                {row?.raceDetail[15].answer[0]}
              </div>
              <div title={row?.raceDetail[15].answer}>
                ({row?.raceDetail[15].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P9 (SPRINT)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail.length > 11) {
          return (
            <>
              <div title={row?.raceDetail[16].answer}>
                {row?.raceDetail[16].answer[0]}
              </div>
              <div title={row?.raceDetail[16].answer}>
                ({row?.raceDetail[16].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P10 (SPRINT)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail.length > 11) {
          return (
            <>
              <div title={row?.raceDetail[17].answer}>
                {row?.raceDetail[17].answer[0]}
              </div>
              <div title={row?.raceDetail[17].answer}>
                ({row?.raceDetail[17].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>FASTEST LAP</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail?.length > 11) {
          return (
            <>
              <div title={row?.raceDetail[18]?.answer}>
                {row?.raceDetail[18].answer[0]}
              </div>
              {row?.raceDetail[18]?.answer[1] ? <div title={row?.raceDetail[18]?.answer}>
                ({row?.raceDetail[18]?.answer[1]})
              </div> : "-"}
            </>
          );
        }
      },
      sortable: true,
    },
  ];

  const tableData = {
    columns,
    data,
  };

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );
  return (
    <>
      <div lg={12} className="w-100">
        <Card className="custom-card overflow-hidden">
          <Card.Body>
            <div className="responsive">
              <Card className="custom-card overflow-hidden">
                <div>
                  <h6
                    className="main-content-label mb-1 fs-20"
                    style={{ marginLeft: "5px" }}>
                    PLayer 18 prediction Detail (F1)
                  </h6>
                </div>
                <div>
                  <DataTableExtensions {...tableData}>
                    <DataTable
                      {...extensions}
                      noHeader
                      persistTableHead
                      pagination
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                      highlightOnHover
                    />
                  </DataTableExtensions>
                </div>
              </Card>
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export const SingleUserTable24 = (props) => {
  const { data } = props;

  const columns = [
    {
      name: <b>USER NAME</b>,
      selector: (row) => row.userName,
      sortable: true,
    },
    {
      name: <b>P1 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[0].answer}>
                {row.raceDetail[0].answer[0]}
              </div>
              <div title={row.raceDetail[0].answer}>
                ({row.raceDetail[0].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P2 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[1].answer}>
                {row.raceDetail[1].answer[0]}
              </div>
              <div title={row.raceDetail[1].answer}>
                ({row.raceDetail[1].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P3 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[2].answer}>
                {row.raceDetail[2].answer[0]}
              </div>
              <div title={row.raceDetail[2].answer}>
                ({row.raceDetail[2].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P4 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[3].answer}>
                {row.raceDetail[3].answer[0]}
              </div>
              <div title={row.raceDetail[3].answer}>
                ({row.raceDetail[3].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P5 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[4].answer}>
                {row.raceDetail[4].answer[0]}
              </div>
              <div title={row.raceDetail[4].answer}>
                ({row.raceDetail[4].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P6 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[5].answer}>
                {row.raceDetail[5].answer[0]}
              </div>
              <div title={row.raceDetail[5].answer}>
                ({row.raceDetail[5].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P7 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[6].answer}>
                {row.raceDetail[6].answer[0]}
              </div>
              <div title={row.raceDetail[6].answer}>
                ({row.raceDetail[6].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P8 (RACE)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[7].answer}>
                {row.raceDetail[7].answer[0]}
              </div>
              <div title={row.raceDetail[7].answer}>
                ({row.raceDetail[7].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P1 (SPRINT)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row?.raceDetail[8]?.answer}>
                {row?.raceDetail[8]?.answer[0]}
              </div>
              <div title={row?.raceDetail[8]?.answer}>
                ({row?.raceDetail[8]?.answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P2 (SPRINT)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[9].answer}>
                {row.raceDetail[9].answer[0]}
              </div>
              <div title={row.raceDetail[9].answer}>
                ({row.raceDetail[9].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P3 (SPRINT)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[10].answer}>
                {row.raceDetail[10].answer[0]}
              </div>
              <div title={row.raceDetail[10].answer}>
                ({row.raceDetail[10].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P4 (SPRINT)</b>,
      selector: (row) => {
        if (row.raceDetail && row.raceDetail.length > 11) {
          return (
            <>
              <div title={row.raceDetail[11].answer}>
                {row.raceDetail[11].answer[0]}
              </div>
              <div title={row.raceDetail[11].answer}>
                ({row.raceDetail[11].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P5 (SPRINT)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail.length > 11) {
          return (
            <>
              <div title={row?.raceDetail[12].answer}>
                {row?.raceDetail[12].answer[0]}
              </div>
              <div title={row?.raceDetail[12].answer}>
                ({row?.raceDetail[12].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P6 (SPRINT)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail.length > 11) {
          return (
            <>
              <div title={row?.raceDetail[13].answer}>
                {row?.raceDetail[13].answer[0]}
              </div>
              <div title={row?.raceDetail[13].answer}>
                ({row?.raceDetail[13].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P7 (SPRINT)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail.length > 11) {
          return (
            <>
              <div title={row?.raceDetail[14].answer}>
                {row?.raceDetail[14].answer[0]}
              </div>
              <div title={row?.raceDetail[14].answer}>
                ({row?.raceDetail[14].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P8 (SPRINT)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail.length > 11) {
          return (
            <>
              <div title={row?.raceDetail[15].answer}>
                {row?.raceDetail[15].answer[0]}
              </div>
              <div title={row?.raceDetail[15].answer}>
                ({row?.raceDetail[15].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P9 (SPRINT)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail.length > 11) {
          return (
            <>
              <div title={row?.raceDetail[16].answer}>
                {row?.raceDetail[16].answer[0]}
              </div>
              <div title={row?.raceDetail[16].answer}>
                ({row?.raceDetail[16].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>P10 (SPRINT)</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail.length > 11) {
          return (
            <>
              <div title={row?.raceDetail[17].answer}>
                {row?.raceDetail[17].answer[0]}
              </div>
              <div title={row?.raceDetail[17].answer}>
                ({row?.raceDetail[17].answer[1]})
              </div>
            </>
          );
        }
      },
      sortable: true,
    },
    {
      name: <b>FASTEST LAP</b>,
      selector: (row) => {
        if (row?.raceDetail && row?.raceDetail?.length > 11) {
          return (
            <>
              <div title={row?.raceDetail[18]?.answer}>
                {row?.raceDetail[18].answer[0]}
              </div>
              {row?.raceDetail[18]?.answer[1] ? <div title={row?.raceDetail[18]?.answer}>
                ({row?.raceDetail[18]?.answer[1]})
              </div> : "-"}
            </>
          );
        }
      },
      sortable: true,
    },
  ];

  const tableData = {
    columns,
    data,
  };

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );
  return (
    <>
      <div lg={12} className="w-100">
        <Card className="custom-card overflow-hidden">
          <Card.Body>
            <div className="responsive">
              <Card className="custom-card overflow-hidden">
                <div>
                  <h6
                    className="main-content-label mb-1 fs-20"
                    style={{ marginLeft: "5px" }}>
                    PLayer 24 prediction Detail (MotoGP)
                  </h6>
                </div>
                <div>
                  <DataTableExtensions {...tableData}>
                    <DataTable
                      {...extensions}
                      noHeader
                      persistTableHead
                      pagination
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                      highlightOnHover
                    />
                  </DataTableExtensions>
                </div>
              </Card>
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export const StandingUserTable = (props) => {
  const {
    data,
    totalRows,
    handlePageChange,
    dataPerPage,
    isLoading,
    setDataPerPage,
    handleSearchData,
    getAllStanding,
    selectedType,
  } = props;
  const {
    open: modalShows,
    handleClickOpen: handleDialogOpen,
    handleClose: handleDialogClose,
  } = useDialogState();
  const navigate = useNavigate();
  const [changes, setChanges] = useState({});
  const [loader, setLoader] = useState(false);
  const [countryData, setCountryData] = useState([]);
  const [openCity, handleOpenCity, handleCloseCity] = useMenuState(false);

  const handleOpen = async (id) => {
    const response = await StandingService.GetSingleStanding(id);
    const result = response.data.data;
    formik.setFieldValue("standingId", result._id);
    formik.setFieldValue("userName", result.userName);
    formik.setFieldValue("totalScore", result.totalScore);
    formik.setFieldValue("threeLatterName", result.threeLatterName);
    formik.setFieldValue("hashtagAssign", result.hashtagAssign);
    formik.setFieldValue("playerCountryName", result.playerCountryName);
    handleDialogOpen();
  };

  const contryStatus = [
    ...countryData.map((item) => ({
      value: item._id,
      label: item.countryName,
    })),
  ];

  const handleFieldChange = (fieldName, value) => {
    setChanges({ ...changes, [fieldName]: value });
  };

  const submit = async (values, action) => {
    try {
      setLoader(true);
      await StandingService.GetStandingUpdate(values.standingId, {
        ...changes,
      });
      setLoader(false);
      handleDialogClose();
      getAllStanding();
      action.resetForm();
    } catch (error) {
      console.error("create race error", error);
      setLoader(false);
    }
  };

  const initialValue = {
    userName: "",
    totalScore: "",
    threeLatterName: "",
    hashtagAssign: "",
    playerCountryName: "",
  };
  const changeCountry = (value) => {
    formik.setFieldValue("playerCountryName", value.label);
    handleFieldChange("playerCountryName", value.label);
  };
  const getCountryList = async () => {
    const response = await CountryService.GetCountryListdrpdown();
    setCountryData(response.data.data);
  };
  useEffect(() => {
    getCountryList();
  }, []);

  const formik = useFormik({
    initialValues: initialValue,
    onSubmit: submit,
  });
  const columns = [
    {
      name: <b>ID</b>,
      // selector: (row) => row.order,
      selector: (row) => (row.order ? Math.floor(row.order) : row.order),
      sortable: true,
    },
    {
      name: <b>FIRST NAME</b>,
      selector: (row) => <div title={row.firstName}>{row.firstName}</div>,
      sortable: true,
    },
    {
      name: <b>LAST NAME</b>,
      selector: (row) => <div title={row.lastName}>{row.lastName}</div>,
      sortable: true,
    },
    {
      name: <b>PLAYER COUNTRY</b>,
      selector: (row) => {
        const countryName = row.playerCountryName;
        return (
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <div>
              <img
                src={row.countryImage !== null ? row.countryImage : countryFlag}
                width="30px"
                height="30px"
                style={{
                  marginLeft: "auto",
                  marginRight: "15px",
                  border: "1px solid",
                  flexShrink: 0,
                }}
                alt="country"
              />
            </div>
            <div
              style={{
                marginLeft: "10px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "120px",
              }}>
              {countryName}
            </div>
          </div>
        );
      },
      sortable: true,
      width: "200px",
    },
    {
      name: <b>RANK</b>,
      selector: (row) => row.hashtagAssign,
      sortable: true,
    },
    {
      name: <b>TOTAL SCORE</b>,
      selector: (row) => row.totalScore,
      sortable: true,
    },
    {
      name: <b>ACTION</b>,
      selector: (row) => (
        <>
          <div className="d-flex">
            <div className="justify-content-center">
              <button
                style={{ marginRight: "10px" }}
                className="btn btn-primary btn-sm"
                onClick={() => handleOpen(row._id)}>
                <i className="fa fa-pencil"></i>
              </button>
              <button
                className="btn btn-primary btn-sm"
                onClick={() =>
                  navigate(`/standinguser?type=${selectedType}`, {
                    state: {
                      id: row._id,
                      userName: row.userName,
                      totalScore: row.totalScore,
                      threeLatterName: row.threeLatterName,
                      hashtagAssign: row.hashtagAssign,
                    },
                  })
                }>
                <i className="fa fa-eye"></i>
              </button>
            </div>
          </div>
        </>
      ),
    },
  ];

  const tableData = {
    columns,
    data,
  };

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );
  return (
    <>
      <div lg={12} className="w-100">
        <Card className="custom-card overflow-hidden">
          <Card.Body>
            <div className="responsive">
              <Card className="custom-card overflow-hidden">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    marginRight: "2px",
                    marginBottom: "10px",
                  }}>
                  <input
                    type="search"
                    style={{
                      border: "1px solid #e8e8f7",
                      padding: "0.375rem 0.75rem",
                      borderRadius: "7px",
                    }}
                    placeholder="Filter Table"
                    onChange={(e) => handleSearchData(e)}
                  />
                </div>
                <div>
                  <DataTableExtensions {...tableData} filter={false}>
                    <DataTable
                      {...extensions}
                      noHeader
                      persistTableHead
                      pagination
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                      highlightOnHover
                      center={true}
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationPerPage={dataPerPage}
                      onChangeRowsPerPage={(page) => setDataPerPage(page)}
                      onChangePage={handlePageChange}
                      progressPending={isLoading}
                      progressComponent={
                        <CircularProgress
                          size={30}
                          style={{ marginTop: "50px" }}
                        />
                      }
                    />
                  </DataTableExtensions>
                </div>
              </Card>
            </div>
          </Card.Body>
        </Card>
      </div>
      {modalShows && (
        <StandingEdit
          show={handleDialogOpen}
          onHide={handleDialogClose}
          handleFieldChange={handleFieldChange}
          formik={formik}
          loader={loader}
          changeCountry={changeCountry}
          contryStatus={contryStatus}
          openCity={openCity}
          handleCloseCity={handleCloseCity}
          handleOpenCity={handleOpenCity}
        />
      )}
    </>
  );
};

export const SeasonsUserTable = (props) => {
  const {
    data,
    totalRows,
    handlePageChange,
    dataPerPage,
    isLoading,
    setDataPerPage,
    getAllSeasons,
    handleData,
  } = props;
  const {
    open: modalShows,
    handleClickOpen: handleDialogOpen,
    handleClose: handleDialogClose,
  } = useDialogState();
  const navigate = useNavigate();
  const [changes, setChanges] = useState({});
  const [loader, setLoader] = useState(false);
  const [countryData, setCountryData] = useState([]);
  const [openCity, handleOpenCity, handleCloseCity] = useMenuState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const handleOpen = async (id) => {
    const response = await StandingService.GetSingleStanding(id);
    const result = response.data.data;
    formik.setFieldValue("standingId", result._id);
    formik.setFieldValue("userName", result.userName);
    formik.setFieldValue("totalScore", result.totalScore);
    formik.setFieldValue("threeLatterName", result.threeLatterName);
    formik.setFieldValue("hashtagAssign", result.hashtagAssign);
    formik.setFieldValue("playerCountryName", result.playerCountryName);
    handleDialogOpen();
  };

  const handlePageChangeWithState = (page) => {
    setCurrentPage(page);
    handlePageChange(page);
  };

  const contryStatus = [
    ...countryData.map((item) => ({
      value: item._id,
      label: item.countryName,
    })),
  ];

  const handleFieldChange = (fieldName, value) => {
    setChanges({ ...changes, [fieldName]: value });
  };

  const submit = async (values, action) => {
    try {
      setLoader(true);
      await StandingService.GetStandingUpdate(values.standingId, {
        ...changes,
      });
      setLoader(false);
      handleDialogClose();
      getAllSeasons();
      action.resetForm();
    } catch (error) {
      console.error("create race error", error);
      setLoader(false);
    }
  };

  const initialValue = {
    userName: "",
    totalScore: "",
    threeLatterName: "",
    hashtagAssign: "",
    playerCountryName: "",
  };
  const changeCountry = (value) => {
    formik.setFieldValue("playerCountryName", value.label);
    handleFieldChange("playerCountryName", value.label);
  };
  const getCountryList = async () => {
    const response = await CountryService.GetCountryListdrpdown();
    setCountryData(response.data.data);
  };
  useEffect(() => {
    getCountryList();
  }, []);

  const formik = useFormik({
    initialValues: initialValue,
    onSubmit: submit,
  });

  const columns = [
    {
      name: <b>ID</b>,
      selector: (_, index) => (currentPage - 1) * dataPerPage + index + 1,
      sortable: true,
    },
    {
      name: <b>Full NAME</b>,
      selector: (row) => (
        <div title={row.fullName}>
          {row.fullName ? row.fullName : `${"\u00A0".repeat(10)}--`}
        </div>
      ),
      sortable: true,
    },
    {
      name: <b>POSITION</b>,
      selector: (row) => (
        <div style={{ marginLeft: "20px" }} title={row.position}>
          {row.position}
        </div>
      ),
      sortable: true,
    },
    {
      name: <b>PLAYER COUNTRY</b>,
      selector: (row) => {
        const countryName = row.playerCountryName;
        return (
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <div>
              <img
                src={row.countryImage !== null ? row.countryImage : countryFlag}
                width="30px"
                height="30px"
                style={{
                  marginLeft: "auto",
                  marginRight: "15px",
                  border: "1px solid",
                  flexShrink: 0,
                }}
                alt="country"
              />
            </div>
            <div
              style={{
                marginLeft: "10px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "120px",
              }}>
              {countryName}
            </div>
          </div>
        );
      },
      sortable: true,
      width: "200px",
    },
    {
      name: <b style={{ marginLeft: "32px" }}>RANK</b>,
      selector: (row) => (
        <div style={{ marginLeft: "45px" }}>{row.ranking}</div>
      ),
      sortable: true,
    },
    {
      name: <b>SEASON</b>,
      selector: (row) => row.season.name,
      sortable: true,
    },
  ];

  const tableData = {
    columns,
    data,
  };

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );
  return (
    <>
      <div lg={12} className="w-100">
        <Card className="custom-card overflow-hidden">
          <Card.Body>
            <div className="responsive">
              <Card className="custom-card overflow-hidden">
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginRight: "2px",
                      marginBottom: "10px",
                    }}>
                    <input
                      type="search"
                      style={{
                        border: "1px solid #e8e8f7",
                        padding: "0.375rem 0.75rem",
                        borderRadius: "7px",
                      }}
                      placeholder="Filter Table"
                      onChange={(e) => handleData(e)}
                    />
                  </div>
                  <DataTableExtensions {...tableData} filter={false}>
                    <DataTable
                      {...extensions}
                      noHeader
                      persistTableHead
                      pagination
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                      highlightOnHover
                      center={true}
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationPerPage={dataPerPage}
                      onChangeRowsPerPage={(page) => setDataPerPage(page)}
                      onChangePage={handlePageChangeWithState}
                      progressPending={isLoading}
                      progressComponent={
                        <CircularProgress
                          size={30}
                          style={{ marginTop: "50px" }}
                        />
                      }
                    />
                  </DataTableExtensions>
                </div>
              </Card>
            </div>
          </Card.Body>
        </Card>
      </div>
      {modalShows && (
        <StandingEdit
          show={handleDialogOpen}
          onHide={handleDialogClose}
          handleFieldChange={handleFieldChange}
          formik={formik}
          loader={loader}
          changeCountry={changeCountry}
          contryStatus={contryStatus}
          openCity={openCity}
          handleCloseCity={handleCloseCity}
          handleOpenCity={handleOpenCity}
        />
      )}
    </>
  );
};

export const SeasonsListTable = (props) => {
  const {
    data,
    totalRows,
    handlePageChange,
    dataPerPage,
    isLoading,
    setDataPerPage,
    getAllSeasons,
    handleData,
  } = props;

  const {
    open: modalShows,
    handleClickOpen: handleDialogOpen,
    handleClose: handleDialogClose,
  } = useDialogState();

  const navigate = useNavigate();
  const [changes, setChanges] = useState({});
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [modalShow, setModalShow] = useState(false);
  const [id, setId] = useState("");
  const handleClose = () => setModalShow(false);

  const handleOpen = async (seasonData) => {
    setId(seasonData._id);
    formik.setFieldValue("name", seasonData.name);
    formik.setFieldValue("year", seasonData.year);
    handleDialogOpen();
  };

  const handlePageChangeWithState = (page) => {
    setCurrentPage(page);
    handlePageChange(page);
  };

  const handleFieldChange = (fieldName, value) => {
    setChanges({ ...changes, [fieldName]: value });
  };

  const submit = async (values, action) => {
    const bodyData = {
      id: id,
      name: values?.name,
      year: values?.year,
    };
    try {
      setLoader(true);
      const response = await SeasonsService.UpdateSeasonsList(bodyData);
      if (response) {
        enqueueSnackbar("Updated successfully!", {
          variant: "success",
        });
        setLoader(false);
        handleDialogClose();
        getAllSeasons();
        action.resetForm();
      }
    } catch (error) {
      console.error("update seasonlist error", error);
      setLoader(false);
    }
  };

  const initialValue = {
    name: "",
    year: "",
  };

  const schema = yup.object().shape({
    name: yup.string().required("Name is Required"),
    year: yup.string().required("Year is Required"),
  });

  const handelShow = (id) => {
    setModalShow(true);
    setId(id);
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });

  const columns = [
    {
      name: <b>ID</b>,
      selector: (_, index) => (currentPage - 1) * dataPerPage + index + 1,
      sortable: true,
    },
    {
      name: <b>SEASON NAME</b>,
      selector: (row) => <div title={row.name}>{row.name}</div>,
      sortable: true,
    },

    {
      name: <b>YEAR</b>,
      selector: (row) => <div title={row.year}>{row.year}</div>,
      sortable: true,
    },

    {
      name: <b>ACTION</b>,
      selector: (row) => (
        <>
          <div className="d-flex">
            <div
              className="justify-content-center"
              style={{ marginLeft: "20px" }}>
              <button
                style={{ marginRight: "10px" }}
                className="btn btn-primary btn-sm"
                onClick={() => handleOpen(row)}>
                <i className="fa fa-pencil"></i>
              </button>
              <button
                style={{ justifyContent: "center" }}
                className="btn btn-danger btn-sm"
                onClick={() => handelShow(row._id)}>
                <i className="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </>
      ),
    },
  ];

  const tableData = {
    columns,
    data,
  };

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );

  const customTableStyles = {
    headCells: {
      style: {
        textAlign: "center",
        justifyContent: "center",
        marginLeft: "20px",
      },
    },
    cells: {
      style: {
        textAlign: "center",
        justifyContent: "center",
      },
    },
  };

  return (
    <>
      <div lg={12} className="w-100">
        <Card className="custom-card overflow-hidden">
          <Card.Body>
            <div className="responsive">
              <Card className="custom-card overflow-hidden">
                <div>
                  {/* <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginRight: "2px",
                      marginBottom: "10px",
                    }}>
                    <input
                      type="search"
                      style={{
                        border: "1px solid #e8e8f7",
                        padding: "0.375rem 0.75rem",
                        borderRadius: "7px",
                      }}
                      placeholder="Filter Table"
                      onChange={(e) => handleData(e)}
                    />
                  </div> */}
                  <DataTableExtensions {...tableData}>
                    <DataTable
                      {...extensions}
                      noHeader
                      persistTableHead
                      pagination
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                      highlightOnHover
                      center={true}
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationPerPage={dataPerPage}
                      onChangeRowsPerPage={(page) => setDataPerPage(page)}
                      onChangePage={handlePageChangeWithState}
                      progressPending={isLoading}
                      customStyles={customTableStyles}
                      progressComponent={
                        <CircularProgress
                          size={30}
                          style={{ marginTop: "50px" }}
                        />
                      }
                    />
                  </DataTableExtensions>
                </div>
              </Card>
            </div>
          </Card.Body>
        </Card>
      </div>

      {modalShow && (
        <DeleteSeasonList
          show={modalShow}
          onHide={handleClose}
          id={id}
          getAllSeasons={getAllSeasons}
        />
      )}

      {modalShows && (
        <AddSeason
          update={true}
          show={handleDialogOpen}
          onHide={handleDialogClose}
          loader={loader}
          formik={formik}
          handleFieldChange={handleFieldChange}
        />
      )}
    </>
  );
};

export const UsersGroupTable = (props) => {
  const {
    data,
    totalRows,
    handlePageChange,
    dataPerPage,
    isLoading,
    setDataPerPage,
    getAllGroups,
    handleData,
  } = props;

  const {
    open: modalShows,
    handleClickOpen: handleDialogOpen,
    handleClose: handleDialogClose,
  } = useDialogState();

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [changes, setChanges] = useState({});
  const [loader, setLoader] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [error, setError] = useState(false);
  const [groupCodeError, setGroupCodeError] = useState("");
  const [groupId, setGroupId] = useState();
  const [groupName, setGroupName] = useState("");
  const [deleteModel, setDeleteModel] = useState("");
  const handleCloseDeleteModel = () => setDeleteModel(false);
  const handleCloseModel = () => setModalShow(false);
  const [currentPage, setCurrentPage] = useState(1);

  const handleOpen = async (id, name, groupCode) => {
    setError(false);
    setGroupCodeError("");
    formik.setFieldValue("groupId", id);
    formik.setFieldValue("name", name);
    formik.setFieldValue("groupCode", groupCode);
    setModalShow(true);
  };

  const handleFieldChange = (fieldName, value) => {
    setChanges({ ...changes, [fieldName]: value });
  };

  const submit = async (values, action) => {
    if (
      values.name === null ||
      values.name === undefined ||
      values.name === ""
    ) {
      setError(true);
      return;
    }
    if (
      values.groupCode === null ||
      values.groupCode === undefined ||
      values.groupCode === ""
    ) {
      setGroupCodeError("please enter group code!");
      return;
    } else if (values.groupCode.length !== 7) {
      setGroupCodeError("group code must be 7 characters long!");
      return;
    }
    try {
      setLoader(true);
      const data = {
        name: values.name,
        groupCode: values.groupCode,
      }
      await GroupService.updatelGroupName(values.groupId, data);
      setLoader(false);
      handleDialogClose();
      getAllGroups();
      action.resetForm();
      setModalShow(false);
      enqueueSnackbar("Group updated successfully!", { variant: "success" });
    } catch (error) {
      console.error("update groupName error", error);
      enqueueSnackbar(`Something went wrong! :${error.response.data.message}`, {
        variant: "error",
      });
      setLoader(false);
    } finally {
      setModalShow(false);
    }
  };

  const handelShow = (id, name) => {
    setDeleteModel(true);
    setGroupId(id);
    setGroupName(name);
  };

  const handlePageChangeWithState = (page) => {
    setCurrentPage(page);
    handlePageChange(page);
  };

  const initialValue = {
    groupId: "",
    name: "",
    groupCode: "",
  };

  const formik = useFormik({
    initialValues: initialValue,
    onSubmit: submit,
  });

  const columns = [
    {
      name: <b>ID</b>,
      selector: (_, index) => (currentPage - 1) * dataPerPage + index + 1,
      sortable: true,
    },

    {
      name: <b>GROUP NAME</b>,
      selector: (row) => <div title={row.name}>{row.name}</div>,
      sortable: true,
    },
    {
      name: <b>GROUP CODE</b>,
      selector: (row) => <div title={row.groupCode}>{row.groupCode}</div>,
      sortable: true,
    },
    {
      name: <b>ACTION</b>,
      selector: (row) => (
        <>
          <div className="d-flex">
            <div className="justify-content-center">
              <button
                style={{ marginRight: "10px" }}
                className="btn btn-primary btn-sm"
                onClick={() => handleOpen(row._id, row.name, row.groupCode)}>
                <i className="fa fa-pencil"></i>
              </button>
              <button
                className="btn btn-primary btn-sm"
                onClick={() =>
                  navigate(`/groups/groupdetails?groupName=${row.name}`, {
                    state: {
                      id: row._id,
                      name: row.name,
                    },
                  })
                }>
                <i className="fa fa-eye"></i>
              </button>
              <button
                style={{ marginLeft: "10px" }}
                className="btn btn-danger btn-sm"
                onClick={() => handelShow(row._id, row.name)}>
                <i className="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </>
      ),
    },
  ];

  const tableData = {
    columns,
    data,
  };

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );
  return (
    <>
      <div lg={12} className="w-100">
        <Card className="custom-card overflow-hidden">
          <Card.Body>
            <div className="responsive">
              <Card className="custom-card overflow-hidden">
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginRight: "2px",
                      marginBottom: "10px",
                    }}>
                    <input
                      type="search"
                      style={{
                        border: "1px solid #e8e8f7",
                        padding: "0.375rem 0.75rem",
                        borderRadius: "7px",
                      }}
                      placeholder="Filter Table"
                      onChange={(e) => handleData(e)}
                    />
                  </div>
                  <DataTableExtensions {...tableData} filter={false}>
                    <DataTable
                      {...extensions}
                      noHeader
                      persistTableHead
                      pagination
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                      highlightOnHover
                      center={true}
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationPerPage={dataPerPage}
                      onChangeRowsPerPage={(page) => setDataPerPage(page)}
                      onChangePage={handlePageChangeWithState}
                      progressPending={isLoading}
                      progressComponent={
                        <CircularProgress
                          size={30}
                          style={{ marginTop: "50px" }}
                        />
                      }
                    />
                  </DataTableExtensions>
                </div>
              </Card>
            </div>
          </Card.Body>
        </Card>
      </div>
      {deleteModel && (
        <DeleteGroup
          show={deleteModel}
          onHide={handleCloseDeleteModel}
          id={groupId}
          getAllGroups={getAllGroups}
          name={groupName}
        />
      )}
      {modalShow && (
        <GroupEdit
          setError={setError}
          setGroupCodeError={setGroupCodeError}
          groupCodeError={groupCodeError}
          show={handleDialogOpen}
          onHide={handleCloseModel}
          loader={loader}
          formik={formik}
          update={true}
          handleFieldChange={handleFieldChange}
          error={error}
        />
      )}
    </>
  );
};
export const ColorCodeTable = (props) => {
  const {
    data,
    totalRows,
    handlePageChange,
    dataPerPage,
    isLoading,
    setDataPerPage,
    getAllStanding,
    handleOpen,
    selectedType,
  } = props;
  const {
    open: modalShows,
    handleClickOpen: handleDialogOpen,
    handleClose: handleDialogClose,
  } = useDialogState();
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState("");
  const [seasonName, setSeasonName] = useState("");
  const handleOpenData = async (id, name) => {
    handleDialogOpen();
    setDeleteId(id);
    setSeasonName(name);
  };

  const columns = [
    {
      name: <b>ID</b>,
      selector: (row) => row._id,
      sortable: true,
    },
    {
      name: <b>SEASON NAME</b>,
      selector: (row) => row.seasonName,
      sortable: true,
    },
    {
      name: <b>ACTION</b>,
      selector: (row) => (
        <>
          <div className="d-flex">
            <div className="justify-content-center">
              <button
                className="btn btn-primary btn-sm"
                onClick={() =>
                  navigate(`/colorcode/${row._id}?type=${selectedType}`, {})
                }>
                <i className="fa fa-eye"></i>
              </button>
              <button
                style={{ marginLeft: "10px" }}
                className="btn btn-primary btn-sm"
                onClick={() => handleOpen(row._id)}>
                <i className="fa fa-pencil"></i>
              </button>
              <button
                style={{ marginLeft: "10px" }}
                className="btn btn-danger btn-sm"
                onClick={() => handleOpenData(row._id, row.seasonName)}>
                <i className="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </>
      ),
    },
  ];

  const tableData = {
    columns,
    data,
  };

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );
  return (
    <>
      <div lg={12} className="w-100">
        <Card className="custom-card overflow-hidden">
          <Card.Body>
            <div className="responsive">
              <Card className="custom-card overflow-hidden">
                <div>
                  <DataTableExtensions {...tableData}>
                    <DataTable
                      {...extensions}
                      noHeader
                      persistTableHead
                      pagination
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                      highlightOnHover
                      center={true}
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationPerPage={dataPerPage}
                      onChangeRowsPerPage={(page) => setDataPerPage(page)}
                      onChangePage={handlePageChange}
                      progressPending={isLoading}
                      progressComponent={
                        <CircularProgress
                          size={30}
                          style={{ marginTop: "50px" }}
                        />
                      }
                    />
                  </DataTableExtensions>
                </div>
              </Card>
            </div>
          </Card.Body>
        </Card>
      </div>
      {modalShows && (
        <DeleteColorCode
          show={handleDialogOpen}
          onHide={handleDialogClose}
          deleteId={deleteId}
          getAllStanding={getAllStanding}
          season={seasonName}
        />
      )}
    </>
  );
};

export const StandingPerUserTable = (props) => {
  const { data, userName, threeLatterName, totalScore, hashtagAssign } = props;
  const columns = [
    {
      name: <b>ID</b>,
      selector: (row) => row._id,
      sortable: true,
    },
    {
      name: <b>COUNTRY</b>,
      selector: (row) => {
        const countryName = row.countryName;
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>
              <img
                src={row.countryImage !== null ? row.countryImage : countryFlag}
                width="30px"
                height="30px"
                style={{
                  marginLeft: "auto",
                  marginRight: "15px",
                  border: "1px solid",
                }}
                alt="country"
              />{" "}
            </div>
            <div style={{ marginLeft: "10px" }}>{countryName}</div>
          </div>
        );
      },
      sortable: true,
      width: "200px",
    },
    {
      name: <b>COUNTRY SHORT NAME</b>,
      selector: (row) => row.countryShortName,
      sortable: true,
    },
    {
      name: <b>SCORE</b>,
      selector: (row) => row.score,
      sortable: true,
    },
  ];

  const tableData = {
    columns,
    data,
  };

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );
  return (
    <>
      <div lg={12} className="w-100">
        <Card className="custom-card overflow-hidden">
          <Card.Body>
            <div className="responsive">
              <Card className="custom-card overflow-hidden">
                <div style={{ display: "flex" }}>
                  {/* <h6
                    className="main-content-label mb-1 fs-20"
                    style={{ marginLeft: "5px", display: "flex" }}
                  > */}
                  <div style={{ marginLeft: "15px" }}>
                    User Name
                    <div style={{ fontWeight: "bold" }}> {userName}</div>
                  </div>
                  <div style={{ marginLeft: "15px" }}>
                    User Short Name
                    <div style={{ fontWeight: "bold" }}> {threeLatterName}</div>
                  </div>
                  <div style={{ marginLeft: "15px" }}>
                    Total Score
                    <div style={{ fontWeight: "bold" }}> {totalScore}</div>
                  </div>
                  <div style={{ marginLeft: "15px" }}>
                    Rank
                    <div style={{ fontWeight: "bold" }}> {hashtagAssign}</div>
                  </div>
                  {/* </h6> */}
                </div>
                <div>
                  <DataTableExtensions {...tableData}>
                    <DataTable
                      {...extensions}
                      noHeader
                      persistTableHead
                      pagination
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                      highlightOnHover
                    />
                  </DataTableExtensions>
                </div>
              </Card>
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export const GroupDetailsTable = (props) => {
  const {
    data,
    getGroupMembers,
    handleData,
    dataPerPage,
    groupId,
    totalRows,
    isLoading,
    handlePageChange,
    setDataPerPage,
    groupName,
  } = props;
  const [deleteModel, setDeleteModel] = useState(false);
  const [memberName, setMemberName] = useState("");
  const [memberId, setMemberId] = useState("");
  const handleCloseDeleteModel = () => setDeleteModel(false);
  const [currentPage, setCurrentPage] = useState(1);

  const handelDeletModelOpen = (id, name) => {
    setDeleteModel(true);
    setMemberId(id);
    setMemberName(name);
  };

  const handlePageChangeWithState = (page) => {
    setCurrentPage(page);
    handlePageChange(page);
  };

  const columns = [
    {
      name: <b>ID</b>,
      selector: (_, index) => (currentPage - 1) * dataPerPage + index + 1,
      sortable: true,
    },
    {
      name: <b>UNIQUE CODE</b>,
      selector: (row) =>
        row.useUniqueCode ? row.useUniqueCode : "\u00A0".repeat(4) + "--",
      sortable: true,
    },
    {
      name: <b>USER NAME</b>,
      selector: (row) =>
        row.userName ? row.userName : "\u00A0".repeat(6) + "--",
      sortable: true,
    },
    {
      name: <b>MEMBERS NAME</b>,
      selector: (row) =>
        row.fullName ? row.fullName : "\u00A0".repeat(5) + "--",
      sortable: true,
    },
    {
      name: <b>MEMBERS COUNTRY</b>,
      selector: (row) => {
        const countryName = row.countryName;
        return (
          <div style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
            <div>
              {row.countryImage ? (
                <img
                  src={row.countryImage !== null ? row.countryImage : ""}
                  width="30px"
                  height="30px"
                  style={{
                    marginLeft: "auto",
                    marginRight: "15px",
                    border: "1px solid",
                  }}
                  alt="country"
                />
              ) : (
                "\u00A0".repeat(12) + "--"
              )}
            </div>
            <div
              style={{
                marginLeft: "10px",
                flexGrow: 1,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}>
              {countryName ? countryName : ""}
            </div>
          </div>
        );
      },
      sortable: true,
      width: "200px",
    },
    {
      name: <b>ACTION</b>,
      selector: (row) => (
        <>
          <div className="d-flex">
            <div className="justify-content-center">
              <button
                style={{ marginLeft: "10px" }}
                className="btn btn-danger btn-sm"
                onClick={() => handelDeletModelOpen(row._id, row.fullName)}>
                <i className="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </>
      ),
    },
  ];

  const tableData = {
    columns,
    data,
  };

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );
  return (
    <>
      <div lg={12} className="w-100">
        <Card className="custom-card overflow-hidden">
          <Card.Body>
            <div className="responsive">
              <Card className="custom-card overflow-hidden">
                <div style={{ display: "grid" }}>
                  <div style={{ marginLeft: "15px", fontWeight: "bold" }}>
                    GROUP MEMBERS DETAILS
                  </div>
                  <div style={{ marginLeft: "15px" }}>
                    GROUP NAME : {groupName}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    marginRight: "2px",
                    marginBottom: "10px",
                  }}>
                  <input
                    type="search"
                    style={{
                      border: "1px solid #e8e8f7",
                      padding: "0.375rem 0.75rem",
                      borderRadius: "7px",
                    }}
                    placeholder="Filter Table"
                    onChange={(e) => handleData(e)}
                  />
                </div>
                <div>
                  <DataTableExtensions {...tableData} filter={false}>
                    <DataTable
                      {...extensions}
                      noHeader
                      persistTableHead
                      pagination
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                      highlightOnHover
                      center={true}
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationPerPage={dataPerPage}
                      onChangeRowsPerPage={(page) => setDataPerPage(page)}
                      onChangePage={handlePageChangeWithState}
                      progressPending={isLoading}
                      progressComponent={
                        <CircularProgress
                          size={30}
                          style={{ marginTop: "50px" }}
                        />
                      }
                    />
                  </DataTableExtensions>
                </div>
              </Card>
            </div>
          </Card.Body>
        </Card>
      </div>
      {deleteModel && (
        <DeleteGroupMember
          show={deleteModel}
          groupId={groupId}
          onHide={handleCloseDeleteModel}
          memberId={memberId}
          getGroupMembers={getGroupMembers}
          name={memberName}
        />
      )}
    </>
  );
};
export const ColorCodePerUserTable = (props) => {
  const { data, isLoading } = props;

  const columns = [
    {
      name: <b>ID</b>,
      selector: (row) => row._id,
      sortable: true,
    },
    {
      name: <b>PLAYER NAME</b>,
      selector: (row) => (
        <>
          <button
            className="btn btn-primary btn-sm"
            style={{
              backgroundColor: row.colorCode,
              color: row.textColorCode,
              border: `1px solid ${row.textColorCode}`,
              width: "80px",
            }}>
            {row.playerName}
          </button>
        </>
      ),
      sortable: true,
    },
  ];

  const tableData = {
    columns,
    data,
  };

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );
  return (
    <>
      <div lg={12} className="w-100">
        <Card className="custom-card overflow-hidden">
          <Card.Body>
            <div className="responsive">
              <Card className="custom-card overflow-hidden">
                <div>
                  <DataTableExtensions {...tableData}>
                    <DataTable
                      {...extensions}
                      noHeader
                      persistTableHead
                      progressPending={isLoading}
                      progressComponent={
                        <CircularProgress
                          size={30}
                          style={{ marginTop: "50px" }}
                        />
                      }
                      pagination
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                      highlightOnHover
                    />
                  </DataTableExtensions>
                </div>
              </Card>
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export const WorldWideTable = (props) => {
  const {
    data,
    totalRows,
    dataPerPage,
    handlePageChange,
    isLoading,
    setDataPerPage,
    type,
    getAllHighScore,
  } = props;

  const {
    open: modalShows,
    handleClickOpen: handleDialogOpen,
    handleClose: handleDialogClose,
  } = useDialogState();
  const [modalShow, setModalShow] = useState(false);
  const [id, setId] = useState("");
  const handleClose = () => setModalShow(false);
  const [name, setName] = useState("");
  const [loader, setLoader] = useState(false);
  const [changes, setChanges] = useState({});
  const [countryData, setCountryData] = useState([]);
  const [openCity, handleOpenCity, handleCloseCity] = useMenuState(false);
  const [openCity2, handleOpenCity2, handleCloseCity2] = useMenuState2(false);

  const handleDelete = async (id, name) => {
    setModalShow(true);
    setId(id);
    setName(name);
  };

  const initialValue = {
    username: "",
    playerCountry: "",
    score: "",
    lastRaceCountry: "",
    playerThreeLatterName: "",
  };

  const contryStatus = [
    ...countryData.map((item) => ({
      value: item._id,
      label: item.countryName,
    })),
  ];

  const contryStatus2 = [
    ...countryData.map((item) => ({
      value: item._id,
      label: item.countryName,
    })),
  ];

  const handleFieldChange = (fieldName, value) => {
    setChanges({ ...changes, [fieldName]: value });
  };

  const getCountryList = async () => {
    const response = await CountryService.GetCountryListdrpdown();
    setCountryData(response.data.data);
  };

  useEffect(() => {
    getCountryList();
  }, []);

  const submit = async (values, action) => {
    try {
      setLoader(true);
      await HighScoreService.UpdateHighScoreSingle(values.highScoreId, {
        ...changes,
      });
      setLoader(false);
      handleDialogClose();
      getAllHighScore();
      action.resetForm();
    } catch (error) {
      console.error("create race error", error);
      setLoader(false);
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    onSubmit: submit,
  });

  const handleOpen = async (id) => {
    handleDialogOpen();
    const response = await HighScoreService.GetHighScoreSingle(id);
    const result = response.data.data;
    formik.setFieldValue("highScoreId", result._id);
    formik.setFieldValue("userName", result.userName);
    formik.setFieldValue("playerCountry", result.playerCountry);
    formik.setFieldValue("score", result.score);
    formik.setFieldValue("lastRaceCountry", result.lastRaceCountry);
    formik.setFieldValue("playerThreeLatterName", result.playerThreeLatterName);
  };

  const changeCountry = (value) => {
    formik.setFieldValue("playerCountry", value.label);
    handleFieldChange("playerCountry", value.label);
  };
  const changeCountry2 = (value) => {
    formik.setFieldValue("lastRaceCountry", value.label);
    handleFieldChange("lastRaceCountry", value.label);
  };

  const columns = [
    {
      name: <b>ID</b>,
      selector: (row) => row.order,
      sortable: true,
    },
    {
      name: <b>FIRST NAME</b>,
      selector: (row) => <div title={row.firstName}>{row.firstName}</div>,
      sortable: true,
    },
    {
      name: <b>LAST NAME</b>,
      selector: (row) => <div title={row.lastName}>{row.lastName}</div>,
      sortable: true,
    },
    {
      name: <b>NICK NAME</b>,
      selector: (row) => row.playerThreeLatterName,
      sortable: true,
    },
    {
      name: <b>RANK</b>,
      selector: (row) => row.raceNumber,
      sortable: true,
    },
    {
      name: <b>PLAYER COUNTRY</b>,
      selector: (row) => {
        const countryName = row.playerCountry;
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>
              <img
                src={
                  row.playerCountryImage !== null
                    ? row.playerCountryImage
                    : countryFlag
                }
                width="30px"
                height="30px"
                style={{
                  marginLeft: "auto",
                  marginRight: "15px",
                  border: "1px solid",
                }}
                alt="country"
              />{" "}
            </div>
            <div style={{ marginLeft: "10px" }}>{countryName}</div>
          </div>
        );
      },
      sortable: true,
      width: "200px",
    },
    {
      name: <b>TOTAL SCORE</b>,
      selector: (row) => row.score,
      sortable: true,
    },
    {
      name: <b>RACE COUNTRY</b>,
      selector: (row) => {
        const countryName = row.lastRaceCountry;
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>
              <img
                src={
                  row.lastRaceCountryImage !== null
                    ? row.lastRaceCountryImage
                    : countryFlag
                }
                width="30px"
                height="30px"
                style={{
                  marginLeft: "auto",
                  marginRight: "15px",
                  border: "1px solid",
                }}
                alt="country"
              />{" "}
            </div>
            <div style={{ marginLeft: "10px" }}>{countryName}</div>
          </div>
        );
      },
      sortable: true,
      width: "200px",
    },
    {
      name: <b>ACTION</b>,
      selector: (row) => (
        <>
          <div className="d-flex">
            <div className="justify-content-center">
              <button
                className="btn btn-primary btn-sm"
                onClick={() => handleOpen(row._id)}>
                <i className="fa fa-pencil"></i>
              </button>
              <button
                style={{ marginLeft: "10px" }}
                className="btn btn-danger btn-sm"
                onClick={() => handleDelete(row._id, row.userName)}>
                <i className="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </>
      ),
      width: "100px",
    },
  ];

  const tableData = {
    columns,
    data,
  };

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );
  return (
    <>
      <div lg={12} className="w-100">
        <Card className="custom-card overflow-hidden">
          <Card.Body>
            <div className="responsive">
              <Card className="custom-card overflow-hidden">
                <div>
                  <DataTableExtensions {...tableData}>
                    <DataTable
                      {...extensions}
                      noHeader
                      persistTableHead
                      pagination
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                      highlightOnHover
                      center={true}
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationPerPage={dataPerPage}
                      onChangeRowsPerPage={(page) => setDataPerPage(page)}
                      onChangePage={handlePageChange}
                      progressPending={isLoading}
                      progressComponent={
                        <CircularProgress
                          size={30}
                          style={{ marginTop: "50px" }}
                        />
                      }
                    />
                  </DataTableExtensions>
                </div>
              </Card>
            </div>
          </Card.Body>
        </Card>
      </div>
      {modalShow && (
        <DeleteHighScoreSingle
          show={modalShow}
          onHide={handleClose}
          id={id}
          type={type}
          name={name}
          getAllHighScore={getAllHighScore}
        />
      )}
      {modalShows && (
        <HighScoreUpdate
          show={handleDialogOpen}
          onHide={handleDialogClose}
          countryData={countryData}
          changeCountry={changeCountry}
          handleFieldChange={handleFieldChange}
          openCity={openCity}
          handleCloseCity={handleCloseCity}
          handleOpenCity={handleOpenCity}
          openCity2={openCity2}
          handleCloseCity2={handleCloseCity2}
          handleOpenCity2={handleOpenCity2}
          loader={loader}
          formik={formik}
          contryStatus={contryStatus}
          contryStatus2={contryStatus2}
          changeCountry2={changeCountry2}
        />
      )}
    </>
  );
};

export const ContinentTable = (props) => {
  const {
    data,
    handleSearchData,
    type,
    getAllHighScore,
    totalRows,
    dataPerPage,
    setDataPerPage,
    handlePageChange,
    isLoading,
  } = props;
  const {
    open: modalShows,
    handleClickOpen: handleDialogOpen,
    handleClose: handleDialogClose,
  } = useDialogState();
  const [loader, setLoader] = useState(false);
  const [changes, setChanges] = useState({});
  const [countryData, setCountryData] = useState([]);
  const [openCity, handleOpenCity, handleCloseCity] = useMenuState(false);
  const [openCity2, handleOpenCity2, handleCloseCity2] = useMenuState2(false);
  const [modalShow, setModalShow] = useState(false);
  const [id, setId] = useState("");
  const handleClose = () => setModalShow(false);
  const [name, setName] = useState("");

  const handleDelete = async (id, name) => {
    setModalShow(true);
    setId(id);
    setName(name);
  };
  const initialValue = {
    username: "",
    playerCountry: "",
    score: "",
    lastRaceCountry: "",
    playerThreeLatterName: "",
  };

  const contryStatus = [
    ...countryData.map((item) => ({
      value: item._id,
      label: item.countryName,
    })),
  ];

  const contryStatus2 = [
    ...countryData.map((item) => ({
      value: item._id,
      label: item.countryName,
    })),
  ];

  const handleFieldChange = (fieldName, value) => {
    setChanges({ ...changes, [fieldName]: value });
  };

  const getCountryList = async () => {
    const response = await CountryService.GetCountryListdrpdown();
    setCountryData(response.data.data);
  };

  useEffect(() => {
    getCountryList();
  }, []);

  const submit = async (values, action) => {
    try {
      setLoader(true);
      await HighScoreService.UpdateHighScoreSingle(values.highScoreId, {
        ...changes,
      });
      setLoader(false);
      handleDialogClose();
      getAllHighScore();
      action.resetForm();
    } catch (error) {
      console.error("create race error", error);
      setLoader(false);
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    onSubmit: submit,
  });

  const handleOpen = async (id) => {
    handleDialogOpen();
    const response = await HighScoreService.GetHighScoreSingle(id);
    const result = response.data.data;
    formik.setFieldValue("highScoreId", result._id);
    formik.setFieldValue("userName", result.userName);
    formik.setFieldValue("playerCountry", result.playerCountry);
    formik.setFieldValue("score", result.score);
    formik.setFieldValue("lastRaceCountry", result.lastRaceCountry);
    formik.setFieldValue("playerThreeLatterName", result.playerThreeLatterName);
    formik.setFieldValue("name", result.countryName);
  };

  const changeCountry = (value) => {
    formik.setFieldValue("playerCountry", value.label);
    handleFieldChange("playerCountry", value.label);
  };
  const changeCountry2 = (value) => {
    formik.setFieldValue("lastRaceCountry", value.label);
    handleFieldChange("lastRaceCountry", value.label);
  };

  const columns = [
    {
      name: <b>ID</b>,
      selector: (row) => row.order,
      sortable: true,
    },
    {
      name: <b>FIRST NAME</b>,
      selector: (row) => <div title={row.firstName}>{row.firstName}</div>,
      sortable: true,
    },
    {
      name: <b>LAST NAME</b>,
      selector: (row) => <div title={row.lastName}>{row.lastName}</div>,
      sortable: true,
    },
    {
      name: <b>NICK NAME</b>,
      selector: (row) => row.playerThreeLatterName,
      sortable: true,
    },
    {
      name: <b>RANK</b>,
      selector: (row) => row.raceNumber,
      sortable: true,
    },
    {
      name: <b>PLAYER COUNTRY</b>,
      selector: (row) => {
        const countryName = row.playerCountry;
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>
              <img
                src={
                  row.playerCountryImage !== null
                    ? row.playerCountryImage
                    : countryFlag
                }
                width="30px"
                height="30px"
                style={{
                  marginLeft: "auto",
                  marginRight: "15px",
                  border: "1px solid",
                }}
                alt="country"
              />{" "}
            </div>
            <div style={{ marginLeft: "10px" }}>{countryName}</div>
          </div>
        );
      },
      sortable: true,
      width: "200px",
    },
    {
      name: <b>TOTAL SCORE</b>,
      selector: (row) => row.score,
      sortable: true,
    },
    {
      name: <b>RACE COUNTRY</b>,
      selector: (row) => {
        const countryName = row.lastRaceCountry;
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>
              <img
                src={
                  row.lastRaceCountryImage !== null
                    ? row.lastRaceCountryImage
                    : countryFlag
                }
                width="30px"
                height="30px"
                style={{
                  marginLeft: "auto",
                  marginRight: "15px",
                  border: "1px solid",
                }}
                alt="country"
              />{" "}
            </div>
            <div style={{ marginLeft: "10px" }}>{countryName}</div>
          </div>
        );
      },
      sortable: true,
      width: "200px",
    },
    {
      name: <b>ACTION</b>,
      selector: (row) => (
        <>
          <div className="d-flex">
            <div className="justify-content-center">
              <button
                className="btn btn-primary btn-sm"
                onClick={() => handleOpen(row._id)}>
                <i className="fa fa-pencil"></i>
              </button>
              <button
                style={{ marginLeft: "10px" }}
                className="btn btn-danger btn-sm"
                onClick={() => handleDelete(row._id, row.userName)}>
                <i className="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </>
      ),
      width: "100px",
    },
  ];

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );
  const tableData = {
    columns,
    data,
  };
  return (
    <>
      <div lg={12} className="w-100">
        <>
          <Card className="custom-card overflow-hidden">
            <Card.Body>
              <div className="responsive">
                <Card className="custom-card overflow-hidden">
                  <div className="card-order">
                    <label className="main-content-label font-weight-bold mb-3 pt-1">
                      {type}
                    </label>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginRight: "2px",
                      marginBottom: "10px",
                    }}>
                    <input
                      type="search"
                      style={{
                        border: "1px solid #e8e8f7",
                        padding: "0.375rem 0.75rem",
                        borderRadius: "7px",
                      }}
                      placeholder="Filter Table"
                      onChange={(e) => handleSearchData(e)}
                    />
                  </div>
                  <div>
                    <DataTableExtensions {...tableData} filter={false}>
                      <DataTable
                        {...extensions}
                        noHeader
                        persistTableHead
                        pagination
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                        }}
                        highlightOnHover
                        center={true}
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={dataPerPage}
                        onChangeRowsPerPage={(page) => setDataPerPage(page)}
                        onChangePage={handlePageChange}
                        progressPending={isLoading}
                        progressComponent={
                          <CircularProgress
                            size={30}
                            style={{ marginTop: "50px" }}
                          />
                        }
                      />
                    </DataTableExtensions>
                  </div>
                </Card>
              </div>
            </Card.Body>
          </Card>
        </>
        {/* )} */}
      </div>
      {modalShow && (
        <DeleteHighScoreSingle
          show={modalShow}
          onHide={handleClose}
          id={id}
          type={type}
          name={name}
          getAllHighScore={getAllHighScore}
        />
      )}

      {modalShows && (
        <HighScoreUpdateContinent
          show={handleDialogOpen}
          onHide={handleDialogClose}
          countryData={countryData}
          changeCountry={changeCountry}
          handleFieldChange={handleFieldChange}
          openCity={openCity}
          handleCloseCity={handleCloseCity}
          handleOpenCity={handleOpenCity}
          openCity2={openCity2}
          handleCloseCity2={handleCloseCity2}
          handleOpenCity2={handleOpenCity2}
          loader={loader}
          formik={formik}
          contryStatus={contryStatus}
          contryStatus2={contryStatus2}
          changeCountry2={changeCountry2}
          type={type}
        />
      )}
    </>
  );
};

export const CountryTable = (props) => {
  const { data, loading, type, getAllHighScore, fetchMore, hasMoreData } =
    props;
  const {
    open: modalShows,
    handleClickOpen: handleDialogOpen,
    handleClose: handleDialogClose,
  } = useDialogState();
  const [loader, setLoader] = useState(false);
  const [changes, setChanges] = useState({});
  const [countryData, setCountryData] = useState([]);
  const [openCity, handleOpenCity, handleCloseCity] = useMenuState(false);
  const [openCity2, handleOpenCity2, handleCloseCity2] = useMenuState2(false);
  const [modalShow, setModalShow] = useState(false);
  const [id, setId] = useState("");
  const handleClose = () => setModalShow(false);
  const [name, setName] = useState("");

  const handleDelete = async (id, name) => {
    setModalShow(true);
    setId(id);
    setName(name);
  };
  const initialValue = {
    username: "",
    playerCountry: "",
    score: "",
    lastRaceCountry: "",
    playerThreeLatterName: "",
  };

  const contryStatus = [
    ...countryData.map((item) => ({
      value: item._id,
      label: item.countryName,
    })),
  ];

  const contryStatus2 = [
    ...countryData.map((item) => ({
      value: item._id,
      label: item.countryName,
    })),
  ];

  useEffect(() => {
    fetchMore();
  }, []);

  const handleFieldChange = (fieldName, value) => {
    setChanges({ ...changes, [fieldName]: value });
  };

  const getCountryList = async () => {
    const response = await CountryService.GetCountryListdrpdown();
    setCountryData(response.data.data);
  };

  useEffect(() => {
    getCountryList();
  }, []);

  const submit = async (values, action) => {
    try {
      setLoader(true);
      await HighScoreService.UpdateHighScoreSingle(values.highScoreId, {
        ...changes,
      });
      setLoader(false);
      handleDialogClose();
      getAllHighScore();
      action.resetForm();
    } catch (error) {
      console.error("create race error", error);
      setLoader(false);
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    onSubmit: submit,
  });

  const handleOpen = async (id) => {
    handleDialogOpen();
    const response = await HighScoreService.GetHighScoreSingle(id);
    const result = response.data.data;
    formik.setFieldValue("highScoreId", result._id);
    formik.setFieldValue("userName", result.userName);
    formik.setFieldValue("playerCountry", result.playerCountry);
    formik.setFieldValue("score", result.score);
    formik.setFieldValue("lastRaceCountry", result.lastRaceCountry);
    formik.setFieldValue("playerThreeLatterName", result.playerThreeLatterName);
    formik.setFieldValue("name", result.countryName);
  };

  const changeCountry = (value) => {
    formik.setFieldValue("playerCountry", value.label);
    handleFieldChange("playerCountry", value.label);
  };
  const changeCountry2 = (value) => {
    formik.setFieldValue("lastRaceCountry", value.label);
    handleFieldChange("lastRaceCountry", value.label);
  };

  const columns = [
    {
      name: <b>ID</b>,
      selector: (row) => row.order,
      sortable: true,
    },
    {
      name: <b>FIRST NAME</b>,
      selector: (row) => <div title={row.firstName}>{row.firstName}</div>,
      sortable: true,
    },
    {
      name: <b>LAST NAME</b>,
      selector: (row) => <div title={row.lastName}>{row.lastName}</div>,
      sortable: true,
    },
    {
      name: <b>NICK NAME</b>,
      selector: (row) => row.playerThreeLatterName,
      sortable: true,
    },
    {
      name: <b>RANK</b>,
      selector: (row) => row.raceNumber,
      sortable: true,
    },
    {
      name: <b>PLAYER COUNTRY</b>,
      selector: (row) => {
        const countryName = row.playerCountry;
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>
              <img
                src={
                  row.playerCountryImage !== null
                    ? row.playerCountryImage
                    : countryFlag
                }
                width="30px"
                height="30px"
                style={{
                  marginLeft: "auto",
                  marginRight: "15px",
                  border: "1px solid",
                }}
                alt="country"
              />{" "}
            </div>
            <div style={{ marginLeft: "10px" }}>{countryName}</div>
          </div>
        );
      },
      sortable: true,
      width: "200px",
    },
    {
      name: <b>TOTAL SCORE</b>,
      selector: (row) => row.score,
      sortable: true,
    },
    {
      name: <b>RACE COUNTRY</b>,
      selector: (row) => {
        const countryName = row.lastRaceCountry;
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>
              <img
                src={
                  row.lastRaceCountryImage !== null
                    ? row.lastRaceCountryImage
                    : countryFlag
                }
                width="30px"
                height="30px"
                style={{
                  marginLeft: "auto",
                  marginRight: "15px",
                  border: "1px solid",
                }}
                alt="country"
              />{" "}
            </div>
            <div style={{ marginLeft: "10px" }}>{countryName}</div>
          </div>
        );
      },
      sortable: true,
      width: "200px",
    },
    {
      name: <b>ACTION</b>,
      selector: (row) => (
        <>
          <div className="d-flex">
            <div className="justify-content-center">
              <button
                className="btn btn-primary btn-sm"
                onClick={() => handleOpen(row._id)}>
                <i className="fa fa-pencil"></i>
              </button>
              <button
                style={{ marginLeft: "10px" }}
                className="btn btn-danger btn-sm"
                onClick={() => handleDelete(row._id, row.userName)}>
                <i className="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </>
      ),
      width: "100px",
    },
  ];

  return (
    <>
      <div lg={12} className="w-100">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "50px",
            }}>
            <CircularProgress size={30} />
          </div>
        ) : (
          <>
            <InfiniteScroll
              dataLength={data.length}
              next={fetchMore}
              hasMore={hasMoreData}
              loader={
                <h4>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <CircularProgress size={30} />
                  </div>
                </h4>
              }
              endMessage={
                <p style={{ display: "flex", justifyContent: "center" }}>
                  <hr style={{ width: "100px", padding: "1px" }} />
                </p>
              }>
              {data.map((continentData) => (
                <Card className="custom-card overflow-hidden">
                  <Card.Body>
                    <div className="responsive">
                      <Card className="custom-card overflow-hidden">
                        <div className="card-order">
                          <label className="main-content-label font-weight-bold mb-3 pt-1">
                            {continentData.ContinentName}
                          </label>
                        </div>
                        <div>
                          <DataTableExtensions
                            columns={columns}
                            data={continentData.ContinentValue}>
                            <DataTable noHeader persistTableHead />
                          </DataTableExtensions>
                        </div>
                      </Card>
                    </div>
                  </Card.Body>
                </Card>
              ))}
            </InfiniteScroll>
          </>
        )}
      </div>
      {modalShow && (
        <DeleteHighScoreSingle
          show={modalShow}
          onHide={handleClose}
          id={id}
          type={type}
          name={name}
          getAllHighScore={getAllHighScore}
        />
      )}

      {modalShows && (
        <HighScoreUpdateContinent
          show={handleDialogOpen}
          onHide={handleDialogClose}
          countryData={countryData}
          changeCountry={changeCountry}
          handleFieldChange={handleFieldChange}
          openCity={openCity}
          handleCloseCity={handleCloseCity}
          handleOpenCity={handleOpenCity}
          openCity2={openCity2}
          handleCloseCity2={handleCloseCity2}
          handleOpenCity2={handleOpenCity2}
          loader={loader}
          formik={formik}
          contryStatus={contryStatus}
          contryStatus2={contryStatus2}
          changeCountry2={changeCountry2}
          type={type}
        />
      )}
    </>
  );
};

export const FeedbackTable = (props) => {
  const [modalShow, setModalShow] = useState(false);
  const [id, setId] = useState("");
  const handleClose = () => setModalShow(false);
  const {
    data,
    totalRows,
    dataPerPage,
    handlePageChange,
    isLoading,
    setDataPerPage,
    getAllFeedback,
  } = props;
  const handleDelete = (id) => {
    setModalShow(true);
    setId(id);
  };

  const columns = [
    {
      name: <b>USER NAME</b>,
      selector: (row) => row.userName,
      sortable: true,
    },
    {
      name: <b>NATIONALITY</b>,
      selector: (row) => row.nationality,
      sortable: true,
    },
    {
      name: <b>ISSUE</b>,
      selector: (row) => <div title={row.issue}>{row.issue}</div>,
      sortable: true,
    },
    {
      name: <b>ACTION</b>,
      selector: (row) => (
        <>
          <div className="d-flex">
            <div className="justify-content-center">
              <button
                className="btn btn-danger btn-sm"
                onClick={() => handleDelete(row._id)}>
                <i className="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </>
      ),
      width: "100px",
    },
  ];

  const tableData = {
    columns,
    data,
  };

  const extensions = useMemo(
    () => ({
      filter: true,
    }),
    []
  );
  return (
    <>
      <div lg={12} className="w-100">
        <Card className="custom-card overflow-hidden">
          <Card.Body>
            <div className="responsive">
              <Card className="custom-card overflow-hidden">
                <div>
                  <DataTableExtensions {...tableData}>
                    <DataTable
                      {...extensions}
                      noHeader
                      progressPending={isLoading}
                      defaultSortField="id"
                      progressComponent={
                        <CircularProgress
                          size={30}
                          style={{ marginTop: "50px" }}
                        />
                      }
                      center={true}
                      persistTableHead
                      pagination
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationPerPage={dataPerPage}
                      onChangeRowsPerPage={(page) => setDataPerPage(page)}
                      onChangePage={handlePageChange}
                      highlightOnHover
                    />
                  </DataTableExtensions>
                </div>
              </Card>
            </div>
          </Card.Body>
        </Card>
      </div>
      {modalShow && (
        <DeleteFeedback
          show={modalShow}
          data={data}
          onHide={handleClose}
          id={id}
          getAllFeedback={getAllFeedback}
        />
      )}
    </>
  );
};
